/*
  Fiche « Thermal Sculpting Smoothing Leggings » (copie conforme) : scripts de la source.
  Le contenu vit dans le shadow DOM de <lsth-page> (sections/lsth-page.liquid). Chaque script de section de la source
  est repris tel quel plus bas ; il reçoit un `document` (LSTH_DOC) dont les recherches d'éléments et les écouteurs
  pointent sur ce shadow DOM. Leur tiroir panier (Upcart) est remplacé par celui de Focal.
  Généré par build/port.py (dossier de la copie, Desktop/Unique Product Page) (ne pas éditer à la main).
*/
(function () {
  'use strict';
  var host = document.querySelector('lsth-page');
  if (!host) return;

  /* Navigateurs sans shadow DOM déclaratif (iOS < 16.4…) : racine attachée à la main. */
  var root = host.shadowRoot;
  if (!root) {
    var tpl = host.querySelector('template[shadowrootmode]');
    if (!tpl) return;
    root = host.attachShadow({ mode: 'open' });
    root.appendChild(tpl.content);
    tpl.remove();
  }
  var bodyEl = root.querySelector('lsth-body');

  /* `document` vu par les scripts de la source. */
  var DOC_EVENTS = { DOMContentLoaded: 1, readystatechange: 1, visibilitychange: 1 };
  var LSTH_DOC = new Proxy(document, {
    get: function (t, k) {
      switch (k) {
        case 'querySelector': return function (s) {
          /* en-tête : celui de Focal (hors de la copie) sert au calcul des décalages de défilement */
          return root.querySelector(s) || (/header/.test(s) ? document.querySelector(s) : null);
        };
        case 'querySelectorAll': return function (s) { return root.querySelectorAll(s); };
        case 'getElementById': return function (id) { return root.getElementById(id); };
        case 'getElementsByClassName': return function (c) { return root.querySelectorAll('.' + String(c).trim().split(/\s+/).join('.')); };
        case 'addEventListener': return function (type, fn, opt) { (DOC_EVENTS[type] ? document : root).addEventListener(type, fn, opt); };
        case 'removeEventListener': return function (type, fn, opt) { (DOC_EVENTS[type] ? document : root).removeEventListener(type, fn, opt); };
        case 'activeElement': return root.activeElement || document.activeElement;
      }
      var v = Reflect.get(t, k);
      return typeof v === 'function' ? v.bind(t) : v;
    }
  });

  /* ------------------------------------------------------------------
     Panier : la source appelle Upcart (window.upcartRefreshCart / upcartOpenCart) après /cart/add.js.
     Ici, mêmes noms, mais c'est le tiroir de Focal qui se met à jour et s'ouvre.
  ------------------------------------------------------------------ */
  var pendingCart = null;
  window.upcartRefreshCart = function () {
    pendingCart = fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
        return cart;
      });
    return pendingCart;
  };
  window.upcartOpenCart = function () {
    Promise.resolve(pendingCart || window.upcartRefreshCart()).then(function (cart) {
      /* sans « sections », le tiroir Focal re-rend sa section mini-cart puis s'ouvre */
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart, openMiniCart: true } }));
    });
  };

  /* Tiroir Focal ouvert (panier, menu, recherche) : la barre collante de la source s'efface. */
  function syncDrawer() {
    var open = !!document.querySelector('cart-drawer[open], mobile-navigation[open], predictive-search-drawer[open], drawer-content[open]');
    if (bodyEl) bodyEl.classList.toggle('lsth-drawer-open', open);
  }
  new MutationObserver(syncDrawer).observe(document.documentElement, { attributes: true, subtree: true, attributeFilter: ['open'] });

/* ---- script de la section lsth_pdp_NCxGEW_lg ---- */
(function (document) {

        (function(){
          var root = document.querySelector('[data-bundle-root]');
          if(!root || root.dataset.init) return; root.dataset.init = '1';
          var DATA = JSON.parse(document.querySelector('[data-bundle-data]').textContent);

          function bccTrack(name, extra){ /* BCC-BEACON 27/09 */ try{ if(window.BCC && typeof window.BCC.track==='function'){ window.BCC.track(name, Object.assign({handle: "maneele-thermal-sculpting-smoothing-leggings", market:(window.Shopify&&Shopify.country)||'', currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'', template: "template--30061390332291__lsth_pdp_NCxGEW_lg", env:(window.BCC.env||'build')}, extra||{})); if(name==='atc_ok' && typeof window.BCC.getSid==='function'){ var _bccSid=window.BCC.getSid(); fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{_bcc_sid:_bccSid}}),keepalive:true}).then(function(r){ if(r&&r.status===200) window.BCC.track('sid_persisted',{sid:_bccSid, handle: "maneele-thermal-sculpting-smoothing-leggings", env:(window.BCC.env||'build')}); }).catch(function(){}); } } }catch(e){} }
          if('IntersectionObserver' in window){
            var _bccSeen = false;
            var _bccIo = new IntersectionObserver(function(entries){
              entries.forEach(function(en){ if(en.isIntersecting && !_bccSeen){ _bccSeen = true; bccTrack('bundle_viewed', {qty: qty}); _bccIo.disconnect(); } });
            });
            _bccIo.observe(root);
          }
          var rowsBox = root.querySelector('[data-bundle-rows]');
          var form = document.getElementById('ls-product-form') || (root.closest('.ls-pdp') && root.closest('.ls-pdp').querySelector('form.ls-form')) || document.querySelector('form.ls-form');
          var DOT = {'sky blue':'#7A93B4','black':'#1D1D1D','orange':'#E78F24','red':'#B01B27','fuchsia':'#C42B8C','white':'#F5F2EC','beige':'#D7C1AC','brown':'#5C3A2E','nude':'#D9B9A3','coffe':'#6B4A34','coffee':'#6B4A34','dark nude':'#B98B72','light blue':'#A9C6E8','mid blue':'#3F6FB5','dark blue':'#22365C','white leopard':'#E8E2D6','grey':'#9A9A9A','gray':'#9A9A9A','mocha':'#7A5540','light nude':'#E7CBB5','wine':'#5E1F2D','navy':'#1F2A44'};
          var qty = parseInt((root.querySelector('.ls-bundle__tile.is-active')||{dataset:{}}).dataset.tier || '3', 10);
          function currentOpts(){
            var inp = form ? form.querySelector('[data-variant-input]') : null;
            var vid = inp ? parseInt(inp.value, 10) : null;
            var v = null;
            for(var i=0;i<DATA.variants.length;i++){ if(DATA.variants[i].id===vid){ v=DATA.variants[i]; break; } }
            return (v || DATA.variants[0]).opts.slice();
          }
          var SW = {}; try { SW = JSON.parse((document.querySelector('[data-bundle-swatches]') || {textContent: '{}'}).textContent) || {}; } catch(e){ console.warn('[bundle] swatch map', e); }
          function dotColor(val){ return SW[String(val)] || DOT[String(val).toLowerCase()] || '#CCC'; }
          function isAvail(v){ return !v || v.available !== false; }
          /* Sentinel 11/09: le tendine non sapevano cosa e' esaurito e /cart/add.js rispondeva 422
             con un "Could not add the bundle" muto. Cascata da sinistra a destra: il colore e'
             attivo se ALMENO una sua taglia c'e', le taglie si filtrano sul colore scelto
             (una regola simmetrica rendeva irraggiungibile White/L partendo da Black/M). */
          function refreshAvail(row){
            var sels = row.querySelectorAll('select');
            sels.forEach(function(sel, si){
              var chosen = []; for(var j=0;j<si;j++) chosen.push(sels[j].value);
              Array.prototype.forEach.call(sel.options, function(o){
                var ok = false;
                for(var i=0;i<DATA.variants.length && !ok;i++){
                  var v = DATA.variants[i];
                  if(v.opts[si] !== o.value || !isAvail(v)) continue;
                  var hit = true; for(var j=0;j<si;j++){ if(v.opts[j] !== chosen[j]){ hit = false; break; } }
                  ok = hit;
                }
                o.disabled = !ok;
                o.textContent = ok ? o.value : o.value + ' \u2014 Sold out';
              });
            });
          }
          function buildRows(){
            rowsBox.querySelectorAll('.ls-bundle__unit').forEach(function(n){ n.remove(); });
            if(qty < 2){ rowsBox.hidden = true; return; }
            var cur = currentOpts();
            for(var u=0; u<qty; u++){
              var row = document.createElement('div'); row.className = 'ls-bundle__unit';
              var tag = document.createElement('span'); tag.className = 'ls-bundle__unittag';
              tag.textContent = '#'+(u+1);
              row.appendChild(tag);
              DATA.opts.forEach(function(opt, oi){
                var isColor = /colou?r|colore/i.test(opt.name); /* Codex #9 */
                var wrap = document.createElement('span');
                wrap.className = 'ls-bundle__selwrap' + (isColor ? ' has-dot' : '');
                var sel = document.createElement('select'); sel.className = 'ls-bundle__select';
                sel.setAttribute('aria-label', opt.name+' unit '+(u+1));
                opt.values.forEach(function(val){
                  var o = document.createElement('option'); o.value = val; o.textContent = val;
                  if(val === cur[oi]) o.selected = true;
                  sel.appendChild(o);
                });
                if(isColor){
                  sel.className += ' ls-bundle__select--native';
                  var dd = document.createElement('div'); dd.className = 'ls-bundle__dd';
                  var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'ls-bundle__dd-btn'; btn.setAttribute('aria-haspopup', 'listbox'); btn.setAttribute('aria-expanded', 'false'); btn.setAttribute('aria-label', opt.name + ' unit ' + (u + 1));
                  var bsw = document.createElement('i'); bsw.className = 'ls-bundle__sw'; var btxt = document.createElement('span'); btn.appendChild(bsw); btn.appendChild(btxt);
                  var list = document.createElement('ul'); list.className = 'ls-bundle__dd-list'; list.hidden = true; list.setAttribute('role', 'listbox');
                  function closeDd(){ list.hidden = true; dd.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }
                  function paint(){ bsw.style.background = dotColor(sel.value); btxt.textContent = sel.value; list.querySelectorAll('li').forEach(function(li){ li.classList.toggle('is-on', li.getAttribute('data-val') === sel.value); li.setAttribute('aria-selected', li.getAttribute('data-val') === sel.value ? 'true' : 'false'); }); }
                  opt.values.forEach(function(val){ var li = document.createElement('li'); li.setAttribute('role', 'option'); li.setAttribute('data-val', val); var i = document.createElement('i'); i.className = 'ls-bundle__sw'; i.style.background = dotColor(val); li.appendChild(i); li.appendChild(document.createTextNode(val)); li.addEventListener('click', function(e){ e.stopPropagation(); sel.value = val; sel.dispatchEvent(new Event('change', {bubbles: true})); closeDd(); }); list.appendChild(li); });
                  btn.addEventListener('click', function(e){ e.stopPropagation(); var open = list.hidden; document.querySelectorAll('.ls-bundle__dd.is-open').forEach(function(x){ x.classList.remove('is-open'); x.querySelector('.ls-bundle__dd-list').hidden = true; x.querySelector('.ls-bundle__dd-btn').setAttribute('aria-expanded', 'false'); }); if(open){ list.hidden = false; dd.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); } });
                  if(!document.body.hasAttribute('data-ls-dd-bound')){ document.body.setAttribute('data-ls-dd-bound', '1'); document.addEventListener('click', function(){ document.querySelectorAll('.ls-bundle__dd.is-open').forEach(function(x){ x.classList.remove('is-open'); x.querySelector('.ls-bundle__dd-list').hidden = true; x.querySelector('.ls-bundle__dd-btn').setAttribute('aria-expanded', 'false'); }); }); document.addEventListener('keydown', function(e){ if(e.key === 'Escape') document.querySelectorAll('.ls-bundle__dd.is-open .ls-bundle__dd-btn').forEach(function(b){ b.click(); }); }); }
                  sel.addEventListener('change', paint); paint();
                  dd.appendChild(btn); dd.appendChild(list); wrap.appendChild(dd);
                }
                wrap.appendChild(sel);
                row.appendChild(wrap);
              });
              rowsBox.appendChild(row);
              refreshAvail(row);
            }
            rowsBox.hidden = false;
          }
          rowsBox.addEventListener('change', function(e){
            var r = e.target.closest && e.target.closest('.ls-bundle__unit');
            if(r) refreshAvail(r);
          }, true);
          function selectTier(tile){
            /* Codex #2: cliccare il tier gia' attivo ricostruiva le righe e buttava via le scelte a mano */
            if(parseInt(tile.dataset.tier,10) === qty && tile.classList.contains('is-active')) return;
            qty = parseInt(tile.dataset.tier, 10);
            bccTrack('bar_selected', {tier: qty});
            syncAtcVisibility();
            root.querySelectorAll('.ls-bundle__tile').forEach(function(t){
              var on = t === tile;
              t.classList.toggle('is-active', on);
              t.setAttribute('aria-checked', on ? 'true' : 'false');
            });
            buildRows();
          }
          root.querySelectorAll('.ls-bundle__tile').forEach(function(tile){
            tile.addEventListener('click', function(e){
              if(e.target.closest('select, .ls-bundle__dd')) return;
              selectTier(tile);
            });
            tile.addEventListener('keydown', function(e){
              /* Codex #1: Space/Enter da dentro una select risaliva fin qui e resettava tutto */
              if(e.target !== tile) return;
              if(e.key === ' ' || e.key === 'Enter'){ e.preventDefault(); selectTier(tile); }
            });
          });
          function findVariant(opts){
            for(var i=0;i<DATA.variants.length;i++){
              var v = DATA.variants[i], hit = true;
              for(var j=0;j<opts.length;j++){ if(v.opts[j] !== opts[j]){ hit = false; break; } }
              if(hit) return v;
            }
            return null;
          }
          function addBundleToCart(){
            /* Codex #5: syncFromMain girava con 60ms di ritardo: chi cambiava colore in alto e
               cliccava subito mandava al carrello la variante precedente */
            try { syncFromMain(); } catch(e){}
            bccTrack('atc', {tier: qty});
            var items = [], ok = true, soldout = false;
            /* Fly 26/09: tier 1 non ha righe, conta la scelta del picker in alto */
            if(qty < 2){
              var one = findVariant(currentOpts());
              if(!one) ok = false; else if(!isAvail(one)) soldout = true; else items.push({id: one.id, quantity: 1});
            } else rowsBox.querySelectorAll('.ls-bundle__unit').forEach(function(row){
              var opts = []; row.querySelectorAll('select').forEach(function(s){ opts.push(s.value); });
              var v = findVariant(opts);
              if(!v){ ok = false; return; }
              if(!isAvail(v)){ soldout = true; return; }
              var ex = null;
              for(var i=0;i<items.length;i++){ if(items[i].id===v.id){ ex = items[i]; break; } }
              if(ex) ex.quantity += 1; else items.push({id: v.id, quantity: 1});
            });
            if(soldout){ alert('One of the selected sizes is sold out. Please pick another size.'); return; }
            if(!ok || !items.length){ alert('This combination is unavailable.'); return; }
            bundleBtn.disabled = true; bundleBtn.textContent = 'Adding...';
            fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({items: items})})
              .then(function(r){
                if(!r.ok){
                  /* Shopify spiega il 422 (es. taglia appena esaurita): quella frase, non un generico */
                  return r.json().catch(function(){ return {}; }).then(function(j){
                    throw new Error(j.description || j.message || 'add failed');
                  });
                }
                bccTrack('atc_ok', {tier: qty, variant_id: (items[0] && items[0].id) || null, items: items.length});
                bundleBtn.disabled = false; bundleBtn.textContent = bundleBtnLabel;
                if(typeof window.upcartRefreshCart === 'function' && typeof window.upcartOpenCart === 'function'){
                  window.upcartRefreshCart();
                  window.upcartOpenCart();
                } else {
                  window.location.href = '/cart';
                }
              })
              .catch(function(e){
                bundleBtn.disabled = false; bundleBtn.textContent = bundleBtnLabel;
                var why = e && e.message && e.message !== 'add failed' ? e.message : '';
                alert(why ? 'Could not add the bundle: ' + why : 'Could not add the bundle. Please try again.');
              });
          }
          /* Dedicated bundle CTA — a shared theme ATC button gets hijacked by cart-drawer apps
             (UpCart etc.) on click before our 'submit' listener ever runs, so multi-item bundles
             silently degrade to a single-item add. A brand-new button no other script targets
             sidesteps that race entirely. */
          var mainAtc = null, bundleBtn = null;
          var bundleBtnLabel = 'ADD TO CART';
          /* This inline script runs mid-parse, BEFORE the theme ATC button below it exists
             in the DOM — so the button must be created lazily, not at script-eval time. */
          function ensureBundleBtn(){
            if(bundleBtn) return true;
            if(!form) return false;
            mainAtc = form.querySelector('[data-atc]');
            if(!mainAtc) return false;
            bundleBtn = document.createElement('button');
            bundleBtn.type = 'button';
            bundleBtn.className = 'ls-atc ls-bundle__atc';
            bundleBtn.textContent = bundleBtnLabel;
            bundleBtn.hidden = true;
            bundleBtn.addEventListener('click', addBundleToCart);
            mainAtc.parentNode.insertBefore(bundleBtn, mainAtc.nextSibling);
            return true;
          }
          function syncAtcVisibility(){
            if(!ensureBundleBtn()) return;
            /* Fly 26/09: al tier 1 il bottone del tema veniva dirottato da UpCart + Fly Bundles, che mettevano nel
               carrello la variante di default (taglia/colore sbagliati). Un solo bottone nostro per tutti i tier, come v2 */
            mainAtc.hidden = true;
            bundleBtn.hidden = false;
          }
          document.addEventListener('DOMContentLoaded', syncAtcVisibility);
/* rule B — Codex #6: il solo click NON e' una modifica: aprire e richiudere una tendina scollegava la riga dal picker principale */ rowsBox.addEventListener('change', function(e){ if(!e.isTrusted) return; var r = e.target.closest && e.target.closest('.ls-bundle__unit'); if(r) r.dataset.lsEdited = '1'; }, true);
          var lastOpts = currentOpts().join('|');
          function syncFromMain(){
            var cur = currentOpts();
            var key = cur.join('|');
            if(key === lastOpts) return;
            var old = lastOpts.split('|'); lastOpts = key;
            rowsBox.querySelectorAll('.ls-bundle__unit').forEach(function(row){
              var sels = row.querySelectorAll('select');
              if(row.dataset.lsEdited) return; /* rule B: a row edited by hand stays (Lucio 2026-09-07) */ cur.forEach(function(val, oi){ /* colour AND size follow the main picker (Lucio 2026-09-07) */ if(val !== old[oi] && sels[oi]){ sels[oi].value = val; sels[oi].dispatchEvent(new Event('change', {bubbles:true})); } });
            });
          }
          document.addEventListener('click', function(e){
            if(root.contains(e.target)) return;
            setTimeout(syncFromMain, 60);
          }, true);
          document.addEventListener('change', function(e){
            if(root.contains(e.target)) return;
            setTimeout(syncFromMain, 60);
          }, true);
          buildRows();
          syncAtcVisibility();
        })();
        
}).call(window, LSTH_DOC);

/* ---- script de la section lsth_pdp_NCxGEW_lg ---- */
(function (document) {

(function(){
  const root = document.querySelector('.ls-pdp[data-product-id="15857765482662"]');
  if(!root) return;

  /* slim variants — id, options, availability, money-formatted prices (Liquid handles market currency), image id */
  const variantsRaw = JSON.parse((document.querySelector('[data-lsth-variants]') || {textContent: '[]'}).textContent);
  const productOptions = ["Color","Size"];
  /* media-indexed: only image media (videos skipped from gallery rendering) — order matches DOM slide order */
  const productImageIds = [
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
];
  /* parallel media id array — only non-video media, matches DOM slide order */
  const productMediaIds = JSON.parse((document.querySelector('[data-lsth-media]') || {textContent: '[]'}).textContent);
  function variantSlideIdx(v){
    if(!v) return -1;
    if(v.featured_image){
      const i = productImageIds.indexOf(v.featured_image.id);
      if(i >= 0) return i;
    }
    if(v.featured_media_id){
      const j = productMediaIds.indexOf(v.featured_media_id);
      if(j >= 0) return j;
    }
    /* fallback: another size of the same colour that has an image (some sizes carry no variant media) */
    try {
      const ci = Array.from(root.querySelectorAll('.ls-option')).findIndex(el => el.classList.contains('ls-option--color'));
      if(ci >= 0 && v.options){
        const alt = variantsRaw.find(x => x !== v && x.options && x.options[ci] === v.options[ci] && (x.featured_media_id || x.featured_image));
        if(alt){
          if(alt.featured_image){ const a = productImageIds.indexOf(alt.featured_image.id); if(a >= 0) return a; }
          if(alt.featured_media_id){ const b = productMediaIds.indexOf(alt.featured_media_id); if(b >= 0) return b; }
        }
      }
    } catch(e){}
    return -1;
  }

  const warmedImgs = (typeof WeakSet === 'function') ? new WeakSet() : { has: () => false, add: () => {} };
  /* Gallery — native scroll-snap.
     The track is a real horizontal scroller (CSS scroll-snap); the browser owns the touch path.
     JS only: derives the visible slide from scrollLeft, runs programmatic jumps (thumbs/arrows/keys/variant),
     keeps an explicit cancellable command (requested vs visible), warms neighbour images. */
  /* ls-gallery native v1 */
  const galMain = root.querySelector('[data-gallery-main]');
  const galTrack = root.querySelector('[data-gallery-track]');
  const slides = root.querySelectorAll('.ls-gallery__slide');
  const thumbs = root.querySelectorAll('.ls-gallery__thumb');
  const galThumbs = root.querySelector('[data-gallery-thumbs]');
  let currentSlide = 0;          /* = requested (what the rest of the section reads) */
  let visible = 0;               /* derived from scrollLeft */
  let cmd = null;                /* {gen, target, startedAt} while a programmatic scroll is outstanding */
  let gen = 0, userDriving = false, idleDone = false;
  const reducedMotion = () => { try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch(e){ return false; } };
  const galReady = !!(galTrack && slides.length > 0);
  function slideLeft(i){
    if(!galReady || !slides[i]) return 0;
    return slides[i].getBoundingClientRect().left - galTrack.getBoundingClientRect().left + galTrack.scrollLeft;
  }
  function nearestIndex(){
    if(!galReady || galTrack.clientWidth === 0) return visible;
    const x = galTrack.scrollLeft; let best = 0, bd = Infinity;
    for(let i = 0; i < slides.length; i++){ const d = Math.abs(slideLeft(i) - x); if(d < bd){ bd = d; best = i; } }
    return best;
  }
  function scrollThumbIntoView(idx, animate){
    if(!galThumbs) return;
    const t = thumbs[idx];
    if(!t) return;
    const target = t.offsetLeft - (galThumbs.clientWidth - t.offsetWidth) / 2;
    const max = galThumbs.scrollWidth - galThumbs.clientWidth;
    const clamped = Math.max(0, Math.min(max, target));
    try {
      galThumbs.scrollTo({ left: clamped, behavior: (animate === false || reducedMotion()) ? 'auto' : 'smooth' });
    } catch(e){
      galThumbs.scrollLeft = clamped;
    }
  }
  function markActive(i, animate){
    slides.forEach((s, idx) => s.classList.toggle('is-active', idx === i));
    thumbs.forEach((t, idx) => { t.classList.toggle('is-active', idx === i); if(idx === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
    scrollThumbIntoView(i, animate);
  }
  function warm(i){
    if(!galReady) return;
    for(let k = i - 1; k <= i + 2; k++){
      const s = slides[k]; if(!s) continue;
      const img = s.querySelector('img'); if(!img || warmedImgs.has(img)) continue; warmedImgs.add(img);
      if(img.loading === 'lazy') img.loading = 'eager';
      if(img.decode) img.decode().catch(() => {});
    }
  }
  function reconcile(){
    visible = nearestIndex();
    if(visible !== currentSlide){ currentSlide = visible; markActive(visible, true); }
  }
  /* command lifecycle: completion = within 1px of target for 150ms; expiry = 1500ms -> reconcile */
  function watchCmd(myGen){
    let quietSince = 0;
    const tick = (now) => {
      if(!cmd || cmd.gen !== myGen) return;
      const d = Math.abs(galTrack.scrollLeft - slideLeft(cmd.target));
      if(d <= 1){ if(!quietSince) quietSince = now; if(now - quietSince >= 150){ cmd = null; visible = currentSlide; return; } }
      else quietSince = 0;
      if(now - cmd.startedAt > 1500){ cmd = null; reconcile(); return; }
      requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }
  /* setSlide(i, animate, opts): relative commands (arrows/keys) wrap, absolute ones clamp; opts.relative, opts.warm */
  function setSlide(i, animate, opts){
    if(slides.length === 0) return;
    opts = opts || {};
    if(opts.relative) i = (i + slides.length) % slides.length; else i = Math.max(0, Math.min(slides.length - 1, i));
    currentSlide = i;
    markActive(i, animate);
    if(opts.warm !== false) warm(i);
    if(!galReady) return;
    cmd = { gen: ++gen, target: i, startedAt: performance.now() };
    const behavior = (animate === false || reducedMotion()) ? 'auto' : 'smooth';
    try { galTrack.scrollTo({ left: slideLeft(i), behavior: behavior }); } catch(e){ galTrack.scrollLeft = slideLeft(i); }
    watchCmd(cmd.gen);
  }
  if(galReady){
    let rafPending = false;
    galTrack.addEventListener('scroll', () => {
      if(rafPending) return; rafPending = true;
      requestAnimationFrame(() => {
        rafPending = false;
        const v = nearestIndex(); if(v === visible) return; visible = v;
        if(cmd) return;                       /* programmatic motion: only track the visible slide */
        currentSlide = v; markActive(v, true); if(userDriving) warm(v);
      });
    }, {passive:true});
    const onUserInput = () => { userDriving = true; if(cmd){ cmd = null; } reconcile(); warm(visible); };
    ['pointerdown', 'touchstart', 'wheel'].forEach(ev => galTrack.addEventListener(ev, onUserInput, {passive:true}));
    /* keyboard on the gallery */
    if(galMain){
      galMain.addEventListener('keydown', (e) => {
        if(e.key === 'ArrowRight'){ e.preventDefault(); setSlide(currentSlide + 1, true, {relative:true}); }
        else if(e.key === 'ArrowLeft'){ e.preventDefault(); setSlide(currentSlide - 1, true, {relative:true}); }
        else if(e.key === 'Home'){ e.preventDefault(); setSlide(0, true); }
        else if(e.key === 'End'){ e.preventDefault(); setSlide(slides.length - 1, true); }
      });
    }
    /* width-only resize: keep the pending destination (or the current slide) aligned */
    let lastW = galTrack.clientWidth;
    const onResize = () => {
      const w = galTrack.clientWidth; if(!w || w === lastW) return; lastW = w;
      requestAnimationFrame(() => setSlide(cmd ? cmd.target : currentSlide, false, {warm:false}));
    };
    if('ResizeObserver' in window){ new ResizeObserver(onResize).observe(galTrack); }
    else window.addEventListener('resize', onResize, {passive:true});
  }
  /* idle: warm the current neighbourhood + prefetch the size-chart modal images (also when the gallery has no slides) */
  const idleWork = () => {
    if(idleDone) return; idleDone = true;
    warm(currentSlide);
    root.querySelectorAll('[data-size-chart] img').forEach(img => { if(img.loading === 'lazy') img.loading = 'eager'; if(img.decode) img.decode().catch(() => {}); });
  };
  const whenIdle = () => { if('requestIdleCallback' in window) requestIdleCallback(idleWork, {timeout: 2000}); else setTimeout(idleWork, 1500); };
  if(document.readyState === 'complete') whenIdle(); else window.addEventListener('load', whenIdle, {once:true});
  thumbs.forEach((t, i) => t.addEventListener('click', () => setSlide(i, true)));
  const prevBtn = root.querySelector('[data-gallery-prev]');
  const nextBtn = root.querySelector('[data-gallery-next]');
  if(prevBtn) prevBtn.addEventListener('click', () => setSlide(currentSlide - 1, true, {relative:true}));
  if(nextBtn) nextBtn.addEventListener('click', () => setSlide(currentSlide + 1, true, {relative:true}));
  /* Initial position */
  setSlide(0, false, {warm:false});

  /* Variant picker */
  const optionEls = root.querySelectorAll('.ls-option');
  const selected = optionEls.length ? Array.from(optionEls).map(el => {
    const active = el.querySelector('[data-option-value].is-active');
    return active ? active.dataset.optionValue : null;
  }) : [];

  function findVariant(){
    if(!optionEls.length) return variantsRaw[0]; /* single-variant product: no option UI */
    return variantsRaw.find(v => v.options.length === productOptions.length && v.options.every((opt, i) => opt === selected[i]));
  }

  /* Variants ship with Liquid-rendered `price_formatted` / `compare_at_formatted` — already correct
     per active market (currency, locale, conversion). No JS-side formatting needed. */
  const discountTpl = "30% OFF";

  function updatePrice(v){
    const label = root.querySelector('[data-atc-label]');
    const btn = root.querySelector('[data-atc]');
    const input = root.querySelector('[data-variant-input]');
    if(!v){ if(label) label.textContent = "Sold Out"; if(btn) btn.disabled = true; return; }
    if(input) input.value = v.id;
    if(btn) btn.disabled = !v.available;
    if(label) label.textContent = v.available
      ? "Add to Cart"
      : "Sold Out";
    const sale = root.querySelector('.ls-price__sale');
    const compare = root.querySelector('.ls-price__compare');
    const badge = root.querySelector('.ls-price__badge');
    if(sale) sale.innerHTML = v.price_formatted;
    if(v.compare_at_price && v.compare_at_price > v.price){
      const pct = Math.round((v.compare_at_price - v.price)/v.compare_at_price*100);
      if(compare){ compare.innerHTML = v.compare_at_formatted; compare.style.display=''; }
      if(badge){ badge.style.display=''; badge.textContent = discountTpl.replace('[pct]', pct); }
    } else {
      if(compare) compare.style.display='none';
      if(badge) badge.style.display='none';
    }
    /* Sticky bar update — scoped to this section instance */
    const stickyScope = document.querySelector('.ls-sticky[data-section-id="template--30061390332291__lsth_pdp_NCxGEW_lg"]');
    const stickySale = stickyScope && stickyScope.querySelector('.ls-sticky__sale');
    const stickyCompare = stickyScope && stickyScope.querySelector('.ls-sticky__compare');
    if(stickySale) stickySale.innerHTML = v.price_formatted;
    if(stickyCompare){
      if(v.compare_at_price && v.compare_at_price > v.price){
        stickyCompare.innerHTML = v.compare_at_formatted; stickyCompare.style.display='';
      } else stickyCompare.style.display='none';
    }
  }

  /* Mark size pills as unavailable (visual X) — but keep clickable so ATC label updates to "Sold Out" */
  function refreshSizeAvailability(){
    optionEls.forEach((el, i) => {
      if(!el.classList.contains('ls-option--size')) return;
      el.querySelectorAll('[data-option-value]').forEach(btn => {
        const probe = selected.slice();
        probe[i] = btn.dataset.optionValue;
        const match = variantsRaw.find(v => v.options.length === productOptions.length && productOptions.every((_, j) => v.options[j] === probe[j] && probe[j] != null));
        const unavailable = !match || !match.available;
        btn.classList.toggle('is-unavailable', unavailable);
        if(unavailable){ btn.setAttribute('aria-disabled','true'); }
        else { btn.removeAttribute('aria-disabled'); }
      });
    });
  }
  refreshSizeAvailability();
  /* Sync ATC label on init (covers case where default variant is sold out) */
  const initVariant = findVariant();
  updatePrice(initVariant);
  /* If non-default variant pre-selected (e.g. via URL params), jump gallery to that variant's slide */
  if(initVariant){
    let initIdx = 0; if(/[?&]variant=/.test(location.search)){ initIdx = modelSlideIdx(initVariant); if(initIdx < 0) initIdx = variantSlideIdx(initVariant); }
    if(initIdx > 0) setSlide(initIdx, false, {warm:false});
  }

  /* ───── Flybundle (Volume Discount) sync — global, runs regardless of Band+Cup mode.
     Mirrors main variant picker selection into every bundle row's dropdowns so users
     don't have to re-pick size/color in each tier. */
  function syncFlybundlesByOption(targetLabel, optionIdx, value){
    if(!value) return;
    try {
      const gfb = window.gfb && window.gfb.gfbVolumeDiscount;
      if(!gfb || !gfb.state || !gfb.f) return;
      const labelIdxStr = String(optionIdx);
      const safeNeedle = String(value).replace(/"/g,'\\"');
      /* Desktop: custom .gfbDropdown components — match by visible label text */
      document.querySelectorAll('.gfbVolumeBundleWrapper').forEach(wrap => {
        wrap.querySelectorAll('.gfbDropdown').forEach(dd => {
          const lbl = dd.previousElementSibling && dd.previousElementSibling.textContent
            ? dd.previousElementSibling.textContent.trim() : '';
          if(lbl !== targetLabel) return;
          const item = dd.querySelector('.gfbDropdownMenuItem[data-label-name="' + safeNeedle + '"]');
          if(!item) return;
          const ds = item.dataset;
          const offerId = ds.offerId, tier = ds.tierCount, varIdx = ds.productVariantIndex;
          const lblIdx = parseInt(ds.labelIndex, 10);
          const slot = gfb.state.currentSelectedOptionsForTiers
            && gfb.state.currentSelectedOptionsForTiers[offerId]
            && gfb.state.currentSelectedOptionsForTiers[offerId][tier]
            && gfb.state.currentSelectedOptionsForTiers[offerId][tier][varIdx];
          if(!slot || !slot.options) return;
          if(slot.options[lblIdx] === value) return;
          slot.options[lblIdx] = value;
          try {
            const fakeEvent = { currentTarget: item, target: item,
              preventDefault(){}, stopPropagation(){}, stopImmediatePropagation(){} };
            gfb.f.gfbVolumeDiscountFindNewVariantForSelectedOption(fakeEvent, value, offerId, varIdx, tier);
          } catch(_){
            try {
              const sel = dd.querySelector('.gfbSelectedMenuOption');
              if(sel) sel.textContent = value;
              const inp = item.querySelector('input[type="radio"]')
                || document.getElementById(item.getAttribute('for') || '');
              if(inp){ inp.checked = true; }
              const joined = (slot.options || []).join('/');
              const vmap = gfb.state.variantsDataByOptions || {};
              const productKey = Object.keys(vmap).find(k => vmap[k] && vmap[k][joined]);
              const variant = productKey ? vmap[productKey][joined] : null;
              if(variant && variant.id){
                const cv = gfb.state.currentSelectedVariantsForTiers
                  && gfb.state.currentSelectedVariantsForTiers[offerId]
                  && gfb.state.currentSelectedVariantsForTiers[offerId][tier]
                  && gfb.state.currentSelectedVariantsForTiers[offerId][tier][varIdx];
                if(cv){ cv.variantId = variant.id; }
              }
            } catch(__){}
          }
        });
      });
      /* Mobile: native <select> per option per row. Filter by first-option labelIndex == option index. */
      document.querySelectorAll('select.gfbVolumeDiscountSingleDropdownSelector').forEach(s => {
        const first = s.options[0];
        if(!first || first.dataset.labelIndex !== labelIdxStr) return;
        const target = Array.from(s.options).find(o => o.value === value);
        if(!target) return;
        const ds = target.dataset;
        const offerId = ds.offerId, tier = ds.tierCount, varIdx = ds.productVariantIndex;
        const lblIdx = parseInt(ds.labelIndex, 10);
        const slot = gfb.state.currentSelectedOptionsForTiers
          && gfb.state.currentSelectedOptionsForTiers[offerId]
          && gfb.state.currentSelectedOptionsForTiers[offerId][tier]
          && gfb.state.currentSelectedOptionsForTiers[offerId][tier][varIdx];
        if(!slot || !slot.options) return;
        if(slot.options[lblIdx] === value && s.value === value) return;
        s.value = value;
        const wrap = s.closest('.gfbDropdownWithCustomIcon');
        const lblEl = wrap ? wrap.querySelector('.gfbSelectedOption') : null;
        if(lblEl) lblEl.textContent = value;
        /* Keep the swatch icon next to the native <select> in sync (fix: icon stayed on old color) */
        const iconImg = wrap ? wrap.querySelector('.gfbSelectedOptionImageWrapper img') : null;
        if(iconImg && target.dataset.imageUrl){ iconImg.src = target.dataset.imageUrl; iconImg.alt = value; }
        s.title = value;
        slot.options[lblIdx] = value;
        try {
          const joined = (slot.options || []).join('/');
          const vmap = gfb.state.variantsDataByOptions || {};
          const productKey = Object.keys(vmap).find(k => vmap[k] && vmap[k][joined]);
          const variant = productKey ? vmap[productKey][joined] : null;
          if(variant && variant.id){
            const cv = gfb.state.currentSelectedVariantsForTiers
              && gfb.state.currentSelectedVariantsForTiers[offerId]
              && gfb.state.currentSelectedVariantsForTiers[offerId][tier]
              && gfb.state.currentSelectedVariantsForTiers[offerId][tier][varIdx];
            if(cv){ cv.variantId = variant.id; }
          }
        } catch(__){}
      });
      try { gfb.f.registerEvents(); } catch(_){}
    } catch(_){}
  }
  /* Expose on root so bandcup IIFE / size-pill flow can call it too */
  root.__syncFlybundlesByOption = syncFlybundlesByOption;

  optionEls.forEach((el, i) => {
    const group = el.querySelector('.ls-option__values');
    if(group){
      group.addEventListener('keydown', e => {
        if(!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End'].includes(e.key)) return;
        const items = Array.from(group.querySelectorAll('[data-option-value]:not([disabled])'));
        if(!items.length) return;
        const idx = items.indexOf(document.activeElement);
        let next = idx;
        if(e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (idx + 1) % items.length;
        else if(e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (idx - 1 + items.length) % items.length;
        else if(e.key === 'Home') next = 0;
        else if(e.key === 'End') next = items.length - 1;
        e.preventDefault();
        items[next].focus();
        items[next].click();
      });
    }
    el.querySelectorAll('[data-option-value]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        el.querySelectorAll('[data-option-value]').forEach(x => { x.classList.remove('is-active'); x.setAttribute('aria-checked','false'); x.setAttribute('tabindex','-1'); });
        btn.classList.add('is-active');
        btn.setAttribute('aria-checked','true');
        btn.setAttribute('tabindex','0');
        selected[i] = btn.dataset.optionValue;
        const sel = el.querySelector('[data-option-selected]');
        if(sel) sel.textContent = btn.dataset.optionValue;
        const v = findVariant();
        updatePrice(v);
        const isColorOption = el.classList.contains('ls-option--color');
        /* Pass isTrusted so synthetic clicks from arrow-key nav don't trigger mobile scroll-to-top */
        swapVariantImage(v, isColorOption, e && e.isTrusted);
        refreshSizeAvailability();
        /* Mirror selection into Flybundle (Volume Discount) rows — defer one tick so
           Flybundle has settled any of its own state transitions before we overwrite. */
        /* Color NOT mirrored into bundle rows (2026-09-04, Lucio) */
        if(!isColorOption){ setTimeout(() => syncFlybundlesByOption(productOptions[i], i, btn.dataset.optionValue), 0); }
      });
    });
  });

  /* Prefetch variant image on hover/touchstart — extra speed before click commits */
  root.querySelectorAll('.ls-option--color [data-option-value]').forEach((btn, idx) => {
    const trigger = () => {
      const val = btn.dataset.optionValue;
      const probe = selected.slice();
      const colorIdx = Array.from(optionEls).findIndex(el => el.classList.contains('ls-option--color'));
      if(colorIdx < 0) return;
      probe[colorIdx] = val;
      const v = variantsRaw.find(vv => productOptions.every((_, j) => vv.options[j] === probe[j]));
      const slideIdx = variantSlideIdx(v);
      if(slideIdx < 0) return;
      const slideImg = slides[slideIdx] && slides[slideIdx].querySelector('img');
      if(!slideImg || warmedImgs.has(slideImg)) return; warmedImgs.add(slideImg);
      if(slideImg.loading === 'lazy'){ slideImg.loading = 'eager'; }
      /* Force off-main-thread decode so click is instant */
      if(slideImg.decode){ slideImg.decode().catch(()=>{}); }
    };
    ['mouseenter', 'touchstart', 'pointerdown', 'focus'].forEach(ev => btn.addEventListener(ev, trigger, {passive:true}));
  });

  /* model_swatch: the slide whose <img alt> is "<colour> - model" for the variant's colour, else the variant image */
  function modelSlideIdx(v){
    try {
      const ci = Array.from(root.querySelectorAll('.ls-option')).findIndex(el => el.classList.contains('ls-option--color'));
      if(ci < 0 || !v || !v.options) return -1;
      const want = (v.options[ci] + ' - model').toLowerCase();
      for(let i = 0; i < slides.length; i++){ const im = slides[i].querySelector('img'); if(im && (im.getAttribute('alt') || '').toLowerCase() === want) return i; }
    } catch(e){}
    return -1;
  }
  function swapVariantImage(v, isColor, isUserClick){
    let idx = modelSlideIdx(v); if(idx < 0) idx = variantSlideIdx(v);
    if(idx < 0) return;
    setSlide(idx, false); /* instant jump — no animation through middle slides */
    /* Color picked by a real user: make sure the swapped image is actually on screen.
       Stacked layout (gallery above buy column) or any layout where the gallery has scrolled out of view. */
    if(isColor && isUserClick){
      const gal = root.querySelector('.ls-gallery');
      if(!gal) return;
      const r = gal.getBoundingClientRect();
      const hidden = r.top < 0 || r.bottom > window.innerHeight;
      if(hidden){
        const header = document.querySelector('header, .header, #header, [class*="header-group"]');
        const off = header ? Math.min(header.getBoundingClientRect().height, 120) : 0;
        const y = window.scrollY + r.top - off - 8;
        window.scrollTo({top: Math.max(0, y), behavior: reducedMotion() ? 'auto' : 'smooth'});
      }
    }
  }

  /* Size chart modal — with focus trap */
  const modal = root.querySelector('[data-size-chart]');
  let modalLastFocus = null;
  function modalFocusable(){
    if(!modal) return [];
    return Array.from(modal.querySelectorAll('button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])')).filter(el => !el.disabled && el.offsetParent !== null);
  }
  function openModal(){
    if(!modal) return;
    modalLastFocus = document.activeElement;
    modal.hidden = false;
    modal.querySelectorAll('img[loading="lazy"]').forEach(im => { im.loading = 'eager'; });
    const f = modalFocusable();
    if(f.length) f[0].focus();
  }
  function closeModal(){
    if(!modal) return;
    modal.hidden = true;
    if(modalLastFocus && typeof modalLastFocus.focus === 'function') modalLastFocus.focus();
  }
  root.querySelectorAll('[data-size-chart-open]').forEach(b => b.addEventListener('click', openModal));
  /* size-chart accordion: promote its lazy images on open (belt and braces over native lazy heuristics) */
  root.querySelectorAll('details').forEach(d => d.addEventListener('toggle', () => { if(d.open) d.querySelectorAll('img[loading="lazy"]').forEach(im => { im.loading = 'eager'; }); }));
  if(modal){ modal.querySelectorAll('[data-size-chart-close]').forEach(b => b.addEventListener('click', closeModal)); }

  /* Size chart US/EU tab toggle */
  root.querySelectorAll('[data-sc-root]').forEach(scope => {
    scope.querySelectorAll('[data-sc-tab]').forEach(tab => {
      tab.addEventListener('click', () => {
        const key = tab.getAttribute('data-sc-tab');
        scope.querySelectorAll('[data-sc-tab]').forEach(t => t.classList.toggle('is-active', t === tab));
        scope.querySelectorAll('[data-sc-panel]').forEach(p => p.classList.toggle('is-active', p.getAttribute('data-sc-panel') === key));
      });
    });
  });

  /* Size & Fit Guide quiz — 3-step funnel: Typical → Band+Cup → Result. */
  (function initSizeQuiz(){
    const quiz = root.querySelector('[data-sfg-quiz]');
    const cfgEl = root.querySelector('[data-bc-config]');
    if(!quiz || !cfgEl) return;
    let cfg; try { cfg = JSON.parse(cfgEl.textContent || '{}'); } catch(e){ return; }
    const bands = cfg.bands || [];
    const cups  = cfg.cups  || [];
    const matrix = cfg.matrix || [];
    const bandUnit = cfg.unit || '';
    const typicalPills = Array.from(quiz.querySelectorAll('[data-sfg-typical-val]'));
    const bandPills = Array.from(quiz.querySelectorAll('[data-sfg-band-val]'));
    const cupPills  = Array.from(quiz.querySelectorAll('[data-sfg-cup-val]'));
    const steps     = Array.from(quiz.querySelectorAll('[data-sfg-step]'));
    const dots      = Array.from(quiz.querySelectorAll('[data-sfg-progress] .ls-sfg__quiz-dot'));
    const backBtn   = quiz.querySelector('[data-sfg-back]');
    const restartBtn= quiz.querySelector('[data-sfg-restart]');
    const formulaBc = quiz.querySelector('[data-sfg-formula-bc]');
    const resultVal = quiz.querySelector('[data-sfg-result-val]');
    const applyBtn  = quiz.querySelector('[data-sfg-apply]');
    const unavail   = quiz.querySelector('[data-sfg-unavail]');
    let curTypical = '', curBand = -1, curCup = -1, curStep = 1;

    function isSizeAvailable(size){
      if(!size) return false;
      const sizeRow = root.querySelectorAll('.ls-option__values')[1]
        || root.querySelector('.ls-option__values');
      if(!sizeRow) return true;
      const pill = sizeRow.querySelector('[data-option-value="' + String(size).replace(/"/g,'\\"') + '"]');
      return !!pill && !pill.disabled && pill.getAttribute('aria-disabled') !== 'true'; /* Sentinel I-4eaa28: sold-out size pills stay clickable and are flagged with aria-disabled, never with .disabled */
    }
    function gotoStep(n){
      curStep = n;
      steps.forEach(s => s.classList.toggle('is-on', parseInt(s.dataset.sfgStep,10) === n));
      dots.forEach((d, i) => d.classList.toggle('is-on', i < n));
      if(backBtn) backBtn.hidden = (n === 1);
    }
    function renderResult(){
      const bandLabel = (bands[curBand] || '').toString().trim();
      const cupLabel  = (cups[curCup]  || '').toString().trim();
      const bandTxt = bandLabel + (bandUnit ? ' ' + bandUnit : '');
      if(formulaBc) formulaBc.textContent = (bandTxt && cupLabel) ? (bandTxt + ' ' + cupLabel) : '—';
      const size = ((matrix[curBand] || [])[curCup] || '').trim() || curTypical;
      resultVal.textContent = size || '—';
      const isAvail = isSizeAvailable(size);
      if(applyBtn){ applyBtn.hidden = !isAvail; applyBtn.dataset.size = size; }
      if(unavail){ unavail.hidden = isAvail || !size; }
    }
    function resetQuiz(){
      curTypical = ''; curBand = -1; curCup = -1;
      typicalPills.forEach(x => x.classList.remove('is-on'));
      bandPills.forEach(x => x.classList.remove('is-on'));
      cupPills.forEach(x => x.classList.remove('is-on'));
      gotoStep(1);
    }
    typicalPills.forEach(p => p.addEventListener('click', () => {
      typicalPills.forEach(x => x.classList.toggle('is-on', x === p));
      curTypical = p.dataset.sfgTypicalVal || '';
      renderResult();
      setTimeout(() => gotoStep(3), 180);
    }));
    function maybeAdvanceFromStep1(){
      if(curBand >= 0 && curCup >= 0){
        renderResult();
        setTimeout(() => gotoStep(2), 180);
      }
    }
    bandPills.forEach(p => p.addEventListener('click', () => {
      bandPills.forEach(x => x.classList.toggle('is-on', x === p));
      curBand = parseInt(p.dataset.sfgBandVal, 10);
      maybeAdvanceFromStep1();
    }));
    cupPills.forEach(p => p.addEventListener('click', () => {
      cupPills.forEach(x => x.classList.toggle('is-on', x === p));
      curCup = parseInt(p.dataset.sfgCupVal, 10);
      maybeAdvanceFromStep1();
    }));
    if(backBtn){
      backBtn.addEventListener('click', () => {
        if(curStep > 1) gotoStep(curStep - 1);
      });
    }
    if(restartBtn){ restartBtn.addEventListener('click', resetQuiz); }
    if(applyBtn){
      applyBtn.addEventListener('click', () => {
        const size = applyBtn.dataset.size;
        if(!size) return;
        const pillRow = root.querySelectorAll('.ls-option__values')[1]
          || root.querySelector('.ls-option__values');
        const pill = pillRow ? pillRow.querySelector('[data-option-value="' + size.replace(/"/g,'\\"') + '"]') : null;
        if(pill && !pill.disabled && pill.getAttribute('aria-disabled') !== 'true'){ pill.click(); }
        const modal = root.querySelector('[data-size-chart]');
        if(modal) modal.hidden = true;
        resetQuiz();
      });
    }
    /* Reset to step 1 every time modal opens (so reopening starts fresh) */
    root.querySelectorAll('[data-size-chart-open]').forEach(b => {
      b.addEventListener('click', () => setTimeout(resetQuiz, 0));
    });
  })();

  /* Delivery countdown card — order within HH:MM:SS → receive date range */
  (function initDeliv(){
    const card = root.querySelector('[data-deliv]');
    if(!card) return;
    const timerEl = card.querySelector('[data-deliv-timer]');
    const rangeEl = card.querySelector('[data-deliv-range]');
    if(!timerEl || !rangeEl) return;
    const cutoffH = parseInt(card.dataset.cutoff, 10);
    const dMin = parseInt(card.dataset.min, 10) || 3;
    const dMax = parseInt(card.dataset.max, 10) || 5;
    const locale = card.dataset.locale || (document.documentElement.lang || 'en');
    function pad(n){ return n < 10 ? '0' + n : '' + n; }
    function addBusinessDays(d, n){
      const out = new Date(d.getTime());
      let added = 0;
      while(added < n){
        out.setDate(out.getDate() + 1);
        const dow = out.getDay();
        if(dow !== 0 && dow !== 6) added++;
      }
      return out;
    }
    function fmtDay(d){
      try { return new Intl.DateTimeFormat(locale, {day:'numeric', month:'short'}).format(d); }
      catch(e){ return d.getDate() + ' ' + d.toLocaleString('en', {month:'short'}); }
    }
    function tick(){
      const now = new Date();
      const cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutoffH, 0, 0, 0);
      // Ship base = today if before cutoff, else tomorrow
      let shipBase;
      if(now < cutoff){
        shipBase = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      } else {
        cutoff.setDate(cutoff.getDate() + 1);
        shipBase = new Date(cutoff.getFullYear(), cutoff.getMonth(), cutoff.getDate());
      }
      // Timer = time until cutoff
      let diff = Math.max(0, cutoff - now);
      const h = Math.floor(diff / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      timerEl.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
      // Range = ship base + min..max business days
      const dStart = addBusinessDays(shipBase, dMin);
      const dEnd   = addBusinessDays(shipBase, dMax);
      rangeEl.textContent = fmtDay(dStart) + ' - ' + fmtDay(dEnd);
    }
    tick();
    setInterval(tick, 1000);
  })();

  /* Shoppable reels — open modal, play video, CTA → variant URL */
  (function initReels(){
    const triggers = root.querySelectorAll('[data-reel-open]');
    if(!triggers.length) return;
    const modal = document.createElement('div'); modal.hidden = true; /* legacy modal removed: LS reel player v2 handles opening (hidden=true keeps the legacy Escape handler inert) */
    const video = modal.querySelector('[data-reel-video]');
    const cta = modal.querySelector('[data-reel-cta]');
    const closes = modal.querySelectorAll('[data-reel-close]');
    function open(t){
      const src = t.getAttribute('data-reel-video') || '';
      const href = t.getAttribute('data-reel-cta') || '#';
      const lbl = t.getAttribute('data-reel-cta-label') || 'Select your size';
      if(src){ video.src = src; }
      cta.href = href;
      cta.textContent = lbl;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      try { video.play(); } catch(e){}
    }
    function close(){
      try { video.pause(); } catch(e){}
      video.removeAttribute('src');
      video.load();
      modal.hidden = true;
      document.body.style.overflow = '';
    }
    /* legacy: click handled by LS reel player v2 */
    closes.forEach(c => c.addEventListener('click', close));
    document.addEventListener('keydown', e => { if(e.key === 'Escape' && !modal.hidden) close(); });

    /* CTA → close modal + smooth-scroll to FlyBundle (bundle picker) */
    if(cta){
      cta.addEventListener('click', (e) => {
        const target = document.querySelector('.ls-flybundle');
        if(!target) return; /* fallback to href */
        e.preventDefault();
        close();
        const headerOffset = 80;
        const top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;
        try { window.scrollTo({ top, behavior: 'smooth' }); }
        catch(err){ window.scrollTo(0, top); }
      });
    }

    /* Lazy inline-autoplay preview: load + play only while in viewport */
    const tiles = root.querySelectorAll('.lsjb-reel');
    if(tiles.length && 'IntersectionObserver' in window){
      const io = new IntersectionObserver((entries) => {
        entries.forEach(en => {
          const tile = en.target;
          const v = tile.querySelector('.lsjb-reel__video');
          if(!v) return;
          const src = v.getAttribute('data-reel-inline');
          if(en.isIntersecting){
            if(src && !v.src){ v.src = src; }
            const p = v.play();
            if(p && p.then){ p.then(() => tile.classList.add('is-playing')).catch(() => {}); }
            else { tile.classList.add('is-playing'); }
          } else {
            try { v.pause(); } catch(e){}
            tile.classList.remove('is-playing');
          }
        });
      }, { threshold: 0.5, rootMargin: '0px' });
      tiles.forEach(t => io.observe(t));
    }
  })();

/* ---- LS reel player v2 (ReelUp-like): one fullscreen stage, vertical swipe, progress, mute, tap-pause, cart, shop ---- */
(function initReelPlayer(){
  const rp = root.querySelector('[data-lsrp]'); if(!rp) return;
  const tiles = Array.prototype.slice.call(root.querySelectorAll('.lsjb-reel'));
  const reels = tiles.map(t => ({ src: t.getAttribute('data-reel-video') || '', poster: (t.querySelector('video') && (t.querySelector('video').getAttribute('data-reel-poster-hd') || t.querySelector('video').getAttribute('poster'))) || '', cta: t.getAttribute('data-reel-cta') || '#' }));
  if(!reels.length) return;
  const stage = rp.querySelector('[data-lsrp-stage]'), track = rp.querySelector('[data-lsrp-track]'), prog = rp.querySelector('[data-lsrp-progress]');
  const playIcon = rp.querySelector('[data-lsrp-playicon]'), muteBtn = rp.querySelector('[data-lsrp-mute]'), shop = rp.querySelector('[data-lsrp-shop]');
  let cur = 0, sound = false, slides = [], dragY = null, dragDX = 0, dragDY = 0, raf = 0, tipTimer = 0, sheetApi = null;
  function slideFor(i){
    if(slides[i]) return slides[i];
    const el = document.createElement('div'); el.className = 'lsrp__slide'; el.style.transform = 'translateY(' + (i * 100) + '%)';
    const v = document.createElement('video'); v.className = 'lsrp__video'; v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', ''); v.setAttribute('disablepictureinpicture', ''); v.preload = 'none'; v.muted = !sound; v.loop = false;
    if(reels[i].poster) v.poster = reels[i].poster;
    v.addEventListener('timeupdate', () => { if(i === cur && v.duration) prog.style.width = (v.currentTime / v.duration * 100) + '%'; });
    v.addEventListener('ended', () => { if(i === cur){ if(cur < reels.length - 1) go(cur + 1); else { v.currentTime = 0; playCur(); } } });
    el.appendChild(v); track.appendChild(el); slides[i] = el; return el;
  }
  function video(i){ const s = slides[i]; return s ? s.querySelector('video') : null; }
  function load(i){ const v = video(i); if(v && !v.getAttribute('src') && reels[i].src){ v.setAttribute('src', reels[i].src); v.preload = 'auto'; v.load(); } }
  function unload(i){ const v = video(i); if(v && v.getAttribute('src')){ try { v.pause(); } catch(e){} v.removeAttribute('src'); v.load(); } }
  function layout(){ track.style.transform = 'translateY(' + (-cur * 100) + '%)'; }
  function playCur(){ const v = video(cur); if(!v) return; v.muted = !sound; playIcon.hidden = true; const p = v.play(); if(p && p.catch) p.catch(() => { /* autoplay with sound refused (no user activation yet) → fall back to muted, never leave the reel stuck */ if(!v.muted){ v.muted = true; sound = false; rp.removeAttribute('data-sound'); const p2 = v.play(); if(p2 && p2.catch) p2.catch(() => { playIcon.hidden = false; }); } else { playIcon.hidden = false; } }); }
  function go(i){
    if(i < 0 || i >= reels.length) return;
    const prev = cur; cur = i;
    slides.forEach((s, k) => { if(Math.abs(k - cur) > 1) unload(k); });
    const pv = video(prev); if(pv && prev !== cur){ try { pv.pause(); pv.currentTime = 0; } catch(e){} }
    slideFor(cur); load(cur); if(cur + 1 < reels.length){ slideFor(cur + 1); load(cur + 1); } if(cur - 1 >= 0){ slideFor(cur - 1); load(cur - 1); }
    prog.style.width = '0%'; layout(); playCur();
    const pb = rp.querySelector('[data-lsrp-prev]'), nb = rp.querySelector('[data-lsrp-next]'); if(pb) pb.disabled = cur === 0; if(nb) nb.disabled = cur === reels.length - 1;
  }
  let lockY = 0, lockedByUs = false, lastFocus = null, savedBody = '';
  function lockScroll(){ if(lockedByUs) return; lockedByUs = true; lockY = window.pageYOffset || 0; savedBody = document.body.style.cssText; document.body.style.cssText += ';position:fixed;top:' + (-lockY) + 'px;left:0;right:0;width:100%;overflow:hidden;'; }
  function unlockScroll(){ if(!lockedByUs) return; lockedByUs = false; document.body.style.cssText = savedBody; /* 2026-09-08: html has scroll-behavior:smooth → a plain scrollTo animated 0→lockY on close (visible top-to-reel scroll); restore instantly */ var de = document.documentElement, sb = de.style.scrollBehavior; de.style.scrollBehavior = 'auto'; window.scrollTo(0, lockY); de.style.scrollBehavior = sb; }
  function open(i){
    lastFocus = document.activeElement; rp.hidden = false; rp.setAttribute('aria-hidden', 'false'); lockScroll();
    rp.removeAttribute('data-tip-off'); clearTimeout(tipTimer); tipTimer = setTimeout(() => rp.setAttribute('data-tip-off', ''), 3500);
    track.style.transition = 'none'; go(i); requestAnimationFrame(() => { track.style.transition = ''; });
    const cb = rp.querySelector('button[data-lsrp-close]'); if(cb && cb.focus) try { cb.focus({preventScroll:true}); } catch(e){}
  }
  function close(){
    const v = video(cur); if(v){ try { v.pause(); } catch(e){} }
    rp.hidden = true; rp.setAttribute('aria-hidden', 'true'); unlockScroll();
    /* 2026-09-08: iOS may pause the inline muted videos (reel tiles, lazy section videos) while the player plays with sound → resume them */
    try { document.querySelectorAll('video.lsjb-reel__video, video.lsq-lazy-video, video.lsic-lazy-video').forEach(function(v){ if(v.currentSrc && v.paused && v.muted && !v.dataset.failed){ var pp = v.play(); if(pp && pp.catch) pp.catch(function(){}); } }); } catch(e){}
    slides.forEach((s, k) => unload(k)); if(sheetApi) sheetApi.close();
    if(lastFocus && lastFocus.focus) try { lastFocus.focus({preventScroll:true}); } catch(e){} lastFocus = null;
  }
  /* focus trap inside the dialog */
  rp.addEventListener('keydown', (e) => {
    if(e.key !== 'Tab') return;
    const f = Array.prototype.filter.call(rp.querySelectorAll('button:not([disabled]),a[href],input,[tabindex]:not([tabindex="-1"])'), el => el.offsetParent !== null);
    if(!f.length) return; const first = f[0], last = f[f.length - 1];
    if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); } else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
  });
  tiles.forEach((t, i) => t.addEventListener('click', (e) => { e.preventDefault(); open(i); }));
  rp.querySelectorAll('[data-lsrp-close]').forEach(b => b.addEventListener('click', close));
  const pbtn = rp.querySelector('[data-lsrp-prev]'), nbtn = rp.querySelector('[data-lsrp-next]');
  if(pbtn) pbtn.addEventListener('click', () => go(cur - 1)); if(nbtn) nbtn.addEventListener('click', () => go(cur + 1));
  if(muteBtn) muteBtn.addEventListener('click', (e) => { e.stopPropagation(); sound = !sound; if(sound) rp.setAttribute('data-sound', ''); else rp.removeAttribute('data-sound'); muteBtn.setAttribute('aria-label', sound ? 'Mute' : 'Unmute'); const v = video(cur); if(v){ v.muted = !sound; if(v.paused) playCur(); } });
  /* tap on the video: pause / resume */
  stage.addEventListener('click', (e) => {
    if(e.target.closest('.lsrp__bottom, .lsrp__top, [data-lsrp-close], [data-lsrp-sheet]')) return;
    if(moved) return;
    const v = video(cur); if(!v) return;
    if(v.paused){ playCur(); } else { v.pause(); playIcon.hidden = false; }
  });
  if(playIcon) playIcon.addEventListener('click', (e) => { e.stopPropagation(); playCur(); });
  /* vertical swipe */
  let startY = 0, startX = 0, moved = false;
  stage.addEventListener('touchstart', (e) => { moved = false; if(e.target.closest('[data-lsrp-sheet]')){ dragY = null; return; } startY = e.touches[0].clientY; startX = e.touches[0].clientX; dragDY = 0; dragDX = 0; dragY = startY; track.style.transition = 'none'; }, {passive:true});
  stage.addEventListener('touchmove', (e) => { if(dragY === null) return; dragDY = e.touches[0].clientY - startY; dragDX = e.touches[0].clientX - startX; if(Math.abs(dragDY) > 8 || Math.abs(dragDX) > 8) moved = true; const lim = ((cur === 0 && dragDY > 0) || (cur === reels.length - 1 && dragDY < 0)) ? dragDY * 0.25 : dragDY; track.style.transform = 'translateY(calc(' + (-cur * 100) + '% + ' + lim + 'px))'; }, {passive:true});
  stage.addEventListener('touchend', () => { if(dragY === null) return; track.style.transition = ''; const dy = dragDY; dragY = null; if(dy < -60 && cur < reels.length - 1) go(cur + 1); else if(dy > 60 && cur > 0) go(cur - 1); else layout(); dragDY = 0; dragDX = 0; }, {passive:true});
  /* desktop: wheel + keys */
  let wheelLock = 0;
  stage.addEventListener('wheel', (e) => { if(rp.hidden || e.target.closest('[data-lsrp-sheet]')) return; e.preventDefault(); const now = Date.now(); if(now - wheelLock < 500) return; if(e.deltaY > 20){ wheelLock = now; go(cur + 1); } else if(e.deltaY < -20){ wheelLock = now; go(cur - 1); } }, {passive:false});
  const onKey = (e) => { if(rp.hidden) return; if(e.key === 'Escape'){ if(sheetApi && sheetApi.isOpen()) sheetApi.close(); else close(); return; } if(sheetApi && sheetApi.isOpen()) return; if(e.key === 'ArrowDown' || e.key === 'ArrowRight') go(cur + 1); else if(e.key === 'ArrowUp' || e.key === 'ArrowLeft') go(cur - 1); };
  document.addEventListener('keydown', onKey);
  document.addEventListener('shopify:section:unload', function u(e){ if(e.target && !e.target.contains(rp)) return; if(!rp.hidden) close(); document.removeEventListener('keydown', onKey); document.removeEventListener('shopify:section:unload', u); });
  /* cart: open the cart drawer if the cart app exposes it, else /cart */
  /* shop now: in-player product sheet; fallback (no sheet markup) = close + scroll to the offer */
  if(shop) shop.addEventListener('click', (e) => { if(sheetApi){ e.preventDefault(); sheetApi.open(); return; } const target = document.querySelector('#ls-bundle-offer') || document.querySelector('.ls-flybundle') || root.querySelector('.ls-buy'); if(!target) return; e.preventDefault(); close(); const top = target.getBoundingClientRect().top + window.pageYOffset - 80; try { window.scrollTo({ top: top, behavior: 'smooth' }); } catch(err){ window.scrollTo(0, top); } });
  /* ---- in-player product sheet (ReelUp "Shop now" clone): pills → variant, quantity, ATC tagged "Reels CC" ---- */
  (function initSheet(){
    const sheet = rp.querySelector('[data-lsrp-sheet]'), dataEl = rp.querySelector('[data-lsrp-variants]'); if(!sheet || !dataEl) return;
    let V = null; try { V = JSON.parse(dataEl.textContent); } catch(e){ console.error('[lsrp] variant JSON invalid', e, dataEl.textContent.slice(0, 200)); return; }
    const priceEl = rp.querySelector('[data-lsrp-price]'), cmpEl = rp.querySelector('[data-lsrp-compare]'), atc = rp.querySelector('[data-lsrp-atc]'), qtyIn = rp.querySelector('[data-lsrp-qtyval]'), countEl = rp.querySelector('[data-lsrp-count]');
    if(!priceEl || !cmpEl || !atc || !countEl){ console.error('[lsrp] sheet markup incomplete'); return; }
    const opts = Array.prototype.slice.call(rp.querySelectorAll('[data-lsrp-opt]'));
    const optVals = opts.map(o => Array.prototype.map.call(o.querySelectorAll('[data-lsrp-pill]'), p => p.getAttribute('data-lsrp-pill')));
    let COLORS = {}; try { const ce = rp.querySelector('[data-lsrp-colors]'); if(ce) COLORS = JSON.parse(ce.textContent) || {}; } catch(e){ console.warn('[lsrp] colour map', e); }
    const isColorOpt = opts.map(o => o.hasAttribute('data-lsrp-opt-color'));
    const tiers = Array.prototype.slice.call(rp.querySelectorAll('[data-lsrp-tier]')), units = rp.querySelector('[data-lsrp-units]'), t1Price = rp.querySelector('[data-lsrp-tier1-price]');
    let tier = (function(){ const on = rp.querySelector('[data-lsrp-tier].is-on'); return on ? parseInt(on.getAttribute('data-lsrp-tier'), 10) || 1 : 1; })();
    const sel = opts.map(o => { const on = o.querySelector('[data-lsrp-pill].is-on') || o.querySelector('[data-lsrp-pill]'); return on ? on.getAttribute('data-lsrp-pill') : ''; });
    const atcLabel = atc.textContent;
    function variant(){ for(let i = 0; i < V.length; i++){ let hit = true; for(let j = 0; j < sel.length; j++){ if(V[i].opts[j] !== sel[j]){ hit = false; break; } } if(hit) return V[i]; } return null; }
    function render(){
      const v = variant();
      opts.forEach((o, oi) => { o.querySelectorAll('[data-lsrp-pill]').forEach(p => p.classList.toggle('is-on', p.getAttribute('data-lsrp-pill') === sel[oi])); const lv = o.querySelector('[data-lsrp-optval]'); if(lv) lv.textContent = sel[oi]; });
      if(v && t1Price) t1Price.textContent = v.price;
      if(units && syncFirst){ syncFirst = false; const first = units.querySelector('.lsrp__unit'); if(first) first.querySelectorAll('select').forEach((s, oi) => { s.value = sel[oi]; const d = s.parentElement.querySelector('.lsrp__cdot'); if(d) d.style.background = COLORS[s.value] || ''; }); }
      const unitsOk = validateUnits();
      if(v){ priceEl.textContent = v.price; cmpEl.textContent = v.compare || ''; cmpEl.hidden = !v.compare; atc.disabled = tier > 1 ? !unitsOk : !v.available; atc.textContent = (tier > 1 ? unitsOk : v.available) ? atcLabel : 'Sold out'; }
      else { console.warn('[lsrp] no variant for selection', sel); atc.disabled = true; atc.textContent = 'Unavailable'; }
    }
    let syncFirst = false;
    opts.forEach((o, oi) => o.addEventListener('click', (e) => { const p = e.target.closest('[data-lsrp-pill]'); if(!p) return; sel[oi] = p.getAttribute('data-lsrp-pill'); syncFirst = true; render(); }));
    function validateUnits(){ if(tier < 2 || !units) return true; let ok = true; units.querySelectorAll('.lsrp__unit').forEach(row => { const v = findVariant(Array.prototype.map.call(row.querySelectorAll('select'), s => s.value)); const bad = !v || !v.available; row.classList.toggle('is-bad', bad); if(bad) ok = false; }); return ok; }
    function clampQty(n){ return Math.max(1, Math.min(10, parseInt(n, 10) || 1)); }
    rp.querySelectorAll('[data-lsrp-qty]').forEach(b => b.addEventListener('click', () => { qtyIn.value = clampQty((parseInt(qtyIn.value, 10) || 1) + parseInt(b.getAttribute('data-lsrp-qty'), 10)); }));
    if(qtyIn) qtyIn.addEventListener('change', () => { qtyIn.value = clampQty(qtyIn.value); });
    /* bundle tiers (same settings as the PDP custom bundle): tier > 1 → one Color/Size row per unit, rows follow the pills until edited */
    function buildUnits(){
      if(!units) return; units.innerHTML = '';
      if(tier < 2){ units.hidden = true; return; }
      for(let u = 0; u < tier; u++){
        const row = document.createElement('div'); row.className = 'lsrp__unit';
        const tag = document.createElement('span'); tag.className = 'lsrp__unittag'; tag.textContent = '#' + (u + 1); row.appendChild(tag);
        opts.forEach((o, oi) => { const wrap = document.createElement('span'); wrap.className = 'lsrp__uwrap' + (isColorOpt[oi] ? ' has-dot' : ''); const s = document.createElement('select'); s.className = 'lsrp__usel'; s.setAttribute('aria-label', (o.querySelector('.lsrp__optlabel') ? o.querySelector('.lsrp__optlabel').textContent.split(':')[0] : 'Option') + ' unit ' + (u + 1)); optVals[oi].forEach(val => { const op = document.createElement('option'); op.value = val; op.textContent = val; if(val === sel[oi]) op.selected = true; s.appendChild(op); }); let dot = null; if(isColorOpt[oi]){ dot = document.createElement('i'); dot.className = 'lsrp__cdot'; dot.style.background = COLORS[s.value] || ''; wrap.appendChild(dot); } s.addEventListener('change', () => { if(dot) dot.style.background = COLORS[s.value] || ''; if(u === 0){ sel[oi] = s.value; } render(); }); wrap.appendChild(s); row.appendChild(wrap); });
        units.appendChild(row);
      }
      units.hidden = false;
    }
    tiers.forEach(t => t.addEventListener('click', () => { tier = parseInt(t.getAttribute('data-lsrp-tier'), 10) || 1; tiers.forEach(x => { const on = x === t; x.classList.toggle('is-on', on); x.setAttribute('aria-checked', on ? 'true' : 'false'); }); buildUnits(); render(); }));
    buildUnits();
    function findVariant(o){ for(let i = 0; i < V.length; i++){ let hit = true; for(let j = 0; j < o.length; j++){ if(V[i].opts[j] !== o[j]){ hit = false; break; } } if(hit) return V[i]; } return null; }
    function cartItems(){
      if(tier > 1 && units){
        const items = []; let bad = 0;
        units.querySelectorAll('.lsrp__unit').forEach(row => { const o = Array.prototype.map.call(row.querySelectorAll('select'), s => s.value); const v = findVariant(o); if(!v || !v.available){ bad++; return; } const ex = items.find(it => it.id === v.id); if(ex) ex.quantity += 1; else items.push({id: v.id, quantity: 1, properties: {'_source': 'Reels CC'}}); });
        return bad ? null : items;
      }
      const v = variant(); if(!v || !v.available) return null;
      return [{id: v.id, quantity: qtyIn ? clampQty(qtyIn.value) : 1, properties: {'_source': 'Reels CC'}}];
    }
    const chartBtn = rp.querySelector('[data-lsrp-sizechart]'), chartImg = rp.querySelector('[data-lsrp-sizechart-img]'), scroller = rp.querySelector('.lsrp__panel-scroll');
    if(chartBtn && !chartImg) chartBtn.remove();
    if(chartBtn && chartImg) chartBtn.addEventListener('click', () => { const g = chartImg.parentElement; try { g.scrollTo({left: chartImg.offsetLeft - (g.clientWidth - chartImg.clientWidth) / 2, behavior: 'smooth'}); } catch(e){ g.scrollLeft = chartImg.offsetLeft; } if(scroller) try { scroller.scrollTo({top: 0, behavior: 'smooth'}); } catch(e){ scroller.scrollTop = 0; } });
    function refreshCount(){ fetch('/cart.js', {credentials:'same-origin'}).then(r => { if(!r.ok) throw new Error('cart.js ' + r.status); return r.json(); }).then(c => { countEl.textContent = c.item_count; countEl.hidden = !c.item_count; }).catch(e => { countEl.hidden = true; console.warn('[lsrp] cart count', e); }); }
    function isOpen(){ return !sheet.hidden; }
    function openSheet(){ render(); refreshCount(); sheet.hidden = false; requestAnimationFrame(() => requestAnimationFrame(() => sheet.classList.add('is-in'))); }
    function closeSheet(){ sheet.classList.remove('is-in'); sheet.hidden = true; }
    rp.querySelectorAll('[data-lsrp-sheet-close]').forEach(b => b.addEventListener('click', (e) => { e.stopPropagation(); closeSheet(); }));
    const gal = rp.querySelector('[data-lsrp-gallery]'), dotsBox = rp.querySelector('[data-lsrp-dots]');
    if(gal && dotsBox){ Array.prototype.forEach.call(gal.querySelectorAll('.lsrp__gimg'), (im, k) => { const d = document.createElement('span'); d.className = 'lsrp__dot' + (k === 0 ? ' is-on' : ''); d.setAttribute('data-lsrp-dot', ''); dotsBox.appendChild(d); }); }
    const dots = Array.prototype.slice.call(rp.querySelectorAll('[data-lsrp-dot]'));
    if(gal && dots.length) gal.addEventListener('scroll', () => { const c = gal.scrollLeft + gal.clientWidth / 2; let i = 0, best = Infinity; Array.prototype.forEach.call(gal.querySelectorAll('.lsrp__gimg'), (im, k) => { const d = Math.abs(im.offsetLeft + im.offsetWidth / 2 - c); if(d < best){ best = d; i = k; } }); dots.forEach((d, k) => d.classList.toggle('is-on', k === i)); }, {passive:true});
    const acc = rp.querySelector('[data-lsrp-acc]'); if(acc && acc.nextElementSibling) acc.addEventListener('click', () => { const b = acc.nextElementSibling; b.hidden = !b.hidden; acc.classList.toggle('is-open', !b.hidden); });
    function toCart(){ if(typeof window.upcartRefreshCart === 'function' && typeof window.upcartOpenCart === 'function'){ try { Promise.resolve(window.upcartRefreshCart()).catch(e => console.warn('[lsrp] upcart refresh', e)); window.upcartOpenCart(); return; } catch(e){ console.warn('[lsrp] upcart failed, falling back to /cart', e); } } window.location.href = '/cart'; }
    /* ATC from the reel: line property _source=Reels CC + cart attribute Reels CC=1 → TrackerShipment webhook tags the order "Reels CC" */
    atc.addEventListener('click', () => {
      const items = cartItems(); if(!items){ alert(tier > 1 ? 'One of the combinations is unavailable. Please change it.' : 'This combination is unavailable.'); return; }
      if(atc.dataset.lsBusy) return; atc.dataset.lsBusy = '1'; /* render() re-enables the button on a variant change: the flag keeps it to one request */
      atc.disabled = true; atc.textContent = 'Adding...';
      /* Sentinel I-8f9307: each request gets its own 12s budget, and the cart is snapshotted before the POST — a timeout or a
         dropped connection after Shopify accepted the add is reconciled against /cart.js instead of asking for a blind retry (double add) */
      const post = (url, body) => fetch(url, {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json', 'Accept':'application/json'}, body: JSON.stringify(body), signal: (typeof AbortSignal !== 'undefined' && AbortSignal.timeout) ? AbortSignal.timeout(12000) : undefined});
      const qtyMap = c => { const m = {}; ((c && c.items) || []).forEach(i => { const k = i.variant_id || i.id; m[k] = (m[k] || 0) + i.quantity; }); return m; };
      const readCart = () => fetch('/cart.js', {credentials:'same-origin', headers:{'Accept':'application/json'}, signal: (typeof AbortSignal !== 'undefined' && AbortSignal.timeout) ? AbortSignal.timeout(8000) : undefined}).then(r => r.ok ? r.json() : null).then(c => c ? qtyMap(c) : null).catch(() => null);
      const wanted = {}; items.forEach(it => { wanted[it.id] = (wanted[it.id] || 0) + it.quantity; });
      let before = null;
      readCart().then(m => { before = m; return post('/cart/add.js', {items: items}); })
        .then(r => { if(r.ok) return r; return r.json().catch(() => ({})).then(j => { const err = new Error(j.description || j.message || ('add failed ' + r.status)); err.shopify = j; throw err; }); })
        .then(() => {
          /* the line is in the cart from here on: the attribute is best-effort, never reported as a failed add (would cause a double add on retry) */
          return post('/cart/update.js', {attributes: {'Reels CC': '1'}}).then(r2 => { if(!r2.ok) console.warn('[lsrp] cart attribute Reels CC not set', r2.status); }).catch(e => console.warn('[lsrp] cart attribute Reels CC not set', e));
        })
        .then(() => { delete atc.dataset.lsBusy; atc.disabled = false; atc.textContent = atcLabel; close(); toCart(); })
        .catch(e => {
          console.error('[lsrp] ATC', e);
          const why = (e && e.shopify && (e.shopify.description || e.shopify.message)) || '';
          return readCart().then(after => {
            let added = 0, requested = 0;
            Object.keys(wanted).forEach(id => { requested += wanted[id]; if(before && after) added += Math.min(wanted[id], Math.max(0, (after[id] || 0) - (before[id] || 0))); });
            delete atc.dataset.lsBusy; render(); atc.disabled = false;
            if(added >= requested){ close(); toCart(); return; }
            if(added > 0){ alert('Only ' + added + ' of ' + requested + ' items could be added' + (why ? ': ' + why : '.')); close(); toCart(); return; }
            /* no answer from Shopify (timeout, lost connection): the add may still land after this read. Show the real cart, never a blind retry */
            if(!why){ close(); toCart(); return; }
            alert(why || 'Could not add to cart. Please try again.');
          });
        });
    });
    const cart2 = rp.querySelector('[data-lsrp-cart2]'); if(cart2) cart2.addEventListener('click', () => { close(); toCart(); });
    sheetApi = { open: openSheet, close: closeSheet, isOpen: isOpen };
  })();
  /* hovering a tile prefetches its video metadata (desktop) */
  tiles.forEach((t, i) => t.addEventListener('mouseenter', () => { slideFor(i); const v = video(i); if(v && !v.getAttribute('src') && reels[i].src){ v.preload = 'metadata'; v.setAttribute('src', reels[i].src); } }, {passive:true, once:true}));
})();


  /* Band + Cup → Size selector (Shapermint-style). Active only when [data-bc-config] is emitted. */
  (function initBandCup(){
    const cfgEl = root.querySelector('[data-bc-config]');
    const bcRoot = root.querySelector('[data-bc-root]');
    if(!cfgEl || !bcRoot) return;
    let cfg;
    try { cfg = JSON.parse(cfgEl.textContent || '{}'); } catch(e){ return; }
    const bands = cfg.bands || [];
    const cups  = cfg.cups  || [];
    const matrix = cfg.matrix || [];
    const unit = cfg.unit || '';
    const fitsPrefix = cfg.fitsPrefix || 'fits:';
    const bandLabel = cfg.bandLabel || 'Band';
    const cupLabel  = cfg.cupLabel  || 'Cup';

    const bandSel = bcRoot.querySelector('[data-bc-band]');
    const cupSel  = bcRoot.querySelector('[data-bc-cup]');
    const sizeSel = bcRoot.querySelector('[data-bc-size]');
    const fitsEl  = bcRoot.querySelector('[data-bc-fits]');
    if(!bandSel || !cupSel || !sizeSel) return;

    /* Set of size values this product actually offers (from sizeSel = option.values). */
    const availableSizes = new Set(
      Array.from(sizeSel.options)
        .map(o => String(o.value || '').trim().toLowerCase())
        .filter(v => v)
    );
    const norm = s => String(s || '').trim().toLowerCase();
    const isAvail = s => availableSizes.has(norm(s));

    /* Per-band: array of cup indices whose matrix cell maps to an available size. */
    const validCupsByBand = bands.map((_, i) => {
      const row = matrix[i] || [];
      const out = [];
      for(let j = 0; j < cups.length; j++){
        if(isAvail(row[j])) out.push(j);
      }
      return out;
    });
    /* Bands that have at least one valid cup. */
    const validBandIdx = bands.map((_, i) => i).filter(i => validCupsByBand[i].length > 0);

    function rebuildBandOptions(){
      bandSel.innerHTML = '';
      const ph = document.createElement('option');
      ph.value = ''; ph.textContent = bandLabel;
      ph.disabled = true; ph.selected = true;
      bandSel.appendChild(ph);
      validBandIdx.forEach(i => {
        const o = document.createElement('option');
        o.value = String(i); /* store index so lookup is exact */
        o.textContent = bands[i] + (unit ? ' ' + unit : '');
        bandSel.appendChild(o);
      });
      bandSel.value = '';
    }
    function rebuildCupOptions(bandIdx){
      cupSel.innerHTML = '';
      const ph = document.createElement('option');
      ph.value = ''; ph.textContent = cupLabel;
      ph.disabled = true; ph.selected = true;
      cupSel.appendChild(ph);
      const allow = (bandIdx >= 0 && validCupsByBand[bandIdx]) ? validCupsByBand[bandIdx] : [];
      if(!allow.length){
        /* No band picked yet → show union of cups that are valid for SOME band */
        const union = new Set();
        validBandIdx.forEach(bi => validCupsByBand[bi].forEach(ci => union.add(ci)));
        Array.from(union).sort((a,b)=>a-b).forEach(ci => {
          const o = document.createElement('option');
          o.value = String(ci); o.textContent = cups[ci];
          cupSel.appendChild(o);
        });
      } else {
        allow.forEach(ci => {
          const o = document.createElement('option');
          o.value = String(ci); o.textContent = cups[ci];
          cupSel.appendChild(o);
        });
      }
      cupSel.value = '';
    }
    rebuildBandOptions();
    rebuildCupOptions(-1);
    /* Also blank the Size dropdown on init (Liquid pre-selects placeholder, but a re-render or theme editor restore may stomp it). */
    if(sizeSel.options.length && sizeSel.options[0].value === ''){ sizeSel.value = ''; }

    /* Pill row lives in the same .ls-option as [data-bc-root] (size option). */
    const sizeOption = bcRoot.closest('.ls-option');
    const pillRow = sizeOption ? sizeOption.querySelector('.ls-option__values') : null;

    function pillFor(value){
      if(!pillRow || !value) return null;
      const norm = String(value).trim().toLowerCase();
      return Array.from(pillRow.querySelectorAll('[data-option-value]'))
        .find(b => String(b.dataset.optionValue || '').trim().toLowerCase() === norm) || null;
    }

    function clickPill(value){
      const p = pillFor(value);
      if(p && !p.disabled && p.getAttribute('aria-disabled') !== 'true'){ /* Sentinel I-f66e89 */
        p.click(); /* fires existing variant-update + price + image swap logic */
        return true;
      }
      return false;
    }

    function currentPillValue(){
      if(!pillRow) return '';
      const a = pillRow.querySelector('[data-option-value].is-active');
      return a ? (a.dataset.optionValue || '') : '';
    }

    /* Sweetheart Wireless Bra Fit Experience glyph */
    const FITS_ICON = '<svg class="ls-bc__fits-ico" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M64.2294 37.6075C63.8347 35.3171 62.9737 33.1322 61.6998 31.1883C61.6454 31.1007 61.5736 31.0253 61.4889 30.9665C61.4041 30.9078 61.3083 30.867 61.2072 30.8468C61.1061 30.8265 61.002 30.8271 60.9012 30.8487C60.8004 30.8702 60.705 30.9122 60.6211 30.9719C60.5371 31.0317 60.4662 31.1081 60.4129 31.1963C60.3596 31.2845 60.3249 31.3827 60.3109 31.4848C60.297 31.587 60.3041 31.6909 60.3319 31.7902C60.3597 31.8894 60.4075 31.982 60.4724 32.0621C61.6198 33.844 62.3968 35.8386 62.7572 37.9271C63.546 42.5137 62.169 46.7671 58.6772 50.5615C58.6098 50.6339 58.5574 50.719 58.5229 50.8117C58.4885 50.9045 58.4727 51.0031 58.4765 51.102C58.4803 51.2009 58.5036 51.2981 58.545 51.3879C58.5865 51.4778 58.6452 51.5586 58.718 51.6257C58.8583 51.754 59.0413 51.8255 59.2314 51.8263C59.3353 51.8265 59.438 51.8049 59.5329 51.7627C59.6278 51.7205 59.7128 51.6587 59.7822 51.5815C64.5762 46.3795 64.8482 41.1095 64.2294 37.6075Z" fill="currentColor"/><path d="M58.8676 35.9414C58.761 35.7778 58.5946 35.6624 58.404 35.6198C58.2134 35.5772 58.0137 35.6109 57.8476 35.7136C57.6799 35.8217 57.5616 35.9916 57.5184 36.1863C57.4751 36.3811 57.5103 36.585 57.6164 36.754C57.7218 36.9172 60.1188 40.7932 56.9364 44.0606C56.861 44.13 56.8005 44.214 56.7586 44.3075C56.7167 44.401 56.6943 44.5021 56.6928 44.6046C56.6912 44.707 56.7106 44.8087 56.7496 44.9035C56.7886 44.9982 56.8465 45.084 56.9198 45.1557C56.993 45.2273 57.0801 45.2833 57.1757 45.3202C57.2713 45.3571 57.3734 45.3741 57.4758 45.3703C57.5782 45.3664 57.6787 45.3418 57.7713 45.2978C57.8639 45.2539 57.9465 45.1915 58.0142 45.1146C61.2204 41.82 59.9794 37.6686 58.8676 35.9414Z" fill="currentColor"/><path d="M5.2428 37.9271C5.60316 35.8386 6.38019 33.844 7.5276 32.0621C7.5925 31.982 7.64032 31.8894 7.66809 31.7902C7.69586 31.6909 7.703 31.587 7.68907 31.4848C7.67514 31.3827 7.64044 31.2845 7.5871 31.1963C7.53376 31.1081 7.46292 31.0317 7.37894 30.9719C7.29496 30.9122 7.19963 30.8702 7.09882 30.8487C6.99801 30.8271 6.89385 30.8265 6.79278 30.8468C6.69171 30.867 6.59586 30.9078 6.51114 30.9665C6.42642 31.0253 6.35464 31.1007 6.3002 31.1883C5.02631 33.1322 4.16531 35.3171 3.7706 37.6075C3.1518 41.1095 3.4306 46.3795 8.2314 51.5815C8.30081 51.6587 8.38575 51.7205 8.48066 51.7627C8.57558 51.8049 8.67833 51.8265 8.7822 51.8263C8.97232 51.8255 9.15534 51.754 9.2956 51.6257C9.36835 51.5586 9.42713 51.4778 9.46858 51.3879C9.51002 51.2981 9.5333 51.2009 9.53709 51.102C9.54088 51.0031 9.52511 50.9045 9.49067 50.8117C9.45623 50.719 9.4038 50.6339 9.3364 50.5615C5.831 46.7637 4.454 42.5001 5.2428 37.9271Z" fill="currentColor"/><path d="M11.322 44.0606C8.1328 40.7932 10.5332 36.9206 10.642 36.754C10.7035 36.6709 10.7472 36.576 10.7706 36.4753C10.7939 36.3746 10.7962 36.2701 10.7775 36.1685C10.7588 36.0668 10.7194 35.97 10.6618 35.8842C10.6041 35.7984 10.5295 35.7253 10.4424 35.6696C10.3554 35.6138 10.2578 35.5765 10.1557 35.56C10.0537 35.5435 9.94932 35.5481 9.84912 35.5736C9.74893 35.5991 9.65504 35.6449 9.57328 35.7081C9.49151 35.7714 9.42362 35.8508 9.3738 35.9414C8.2654 37.6686 7.021 41.8064 10.251 45.1214C10.3187 45.1983 10.4013 45.2607 10.4939 45.3046C10.5865 45.3486 10.687 45.3732 10.7894 45.3771C10.8918 45.3809 10.9939 45.3639 11.0895 45.327C11.1851 45.2901 11.2722 45.2341 11.3454 45.1625C11.4187 45.0908 11.4766 45.005 11.5156 44.9103C11.5546 44.8155 11.574 44.7138 11.5724 44.6114C11.5709 44.5089 11.5485 44.4078 11.5066 44.3143C11.4647 44.2208 11.4042 44.1368 11.3288 44.0674L11.322 44.0606Z" fill="currentColor"/><path d="M54.9712 35.8735C54.5598 33.1331 53.7098 23.8239 53.2508 18.8225C53.1284 17.4625 53.0298 16.4051 52.9754 15.8373V15.8135C52.9293 15.4988 52.807 15.2002 52.6191 14.9437C52.4313 14.6871 52.1836 14.4803 51.8976 14.3413C51.2861 14.0964 50.691 13.8125 50.116 13.4913C49.8294 13.3447 49.5131 13.2656 49.1912 13.2601C48.9789 13.2566 48.769 13.3044 48.5792 13.3995C48.3572 13.5042 48.1588 13.6528 47.9957 13.8363C47.8327 14.0198 47.7085 14.2343 47.6306 14.4671L47.4572 14.9805V15.0009C46.24 19.5025 44.8018 22.6985 43.18 24.4801C40.46 27.4517 36.941 29.3047 34 29.3115C31.059 29.3183 27.54 27.4653 24.82 24.4801C23.205 22.6849 21.76 19.4889 20.5564 14.9873V14.9669L20.383 14.4467C20.304 14.2149 20.1793 14.0013 20.0164 13.8185C19.8535 13.6358 19.6556 13.4875 19.4344 13.3825C19.2438 13.2901 19.0342 13.2435 18.8224 13.2465C18.5067 13.2518 18.1964 13.3285 17.9146 13.4709C17.3344 13.7953 16.7335 14.0815 16.116 14.3277C15.8308 14.4674 15.5839 14.6744 15.3967 14.9309C15.2095 15.1874 15.0876 15.4857 15.0416 15.7999V15.8237C14.9872 16.3915 14.8886 17.4523 14.7662 18.8089C14.28 23.8239 13.4402 33.1331 13.0288 35.8667C12.4984 40.2187 13.1342 43.4249 15.164 46.6005C15.529 47.0788 15.8022 47.6206 15.9698 48.1985C16.0548 48.8275 16.3098 52.4689 16.3098 52.9041C16.3099 53.1681 16.3626 53.4294 16.4648 53.6728C16.5669 53.9162 16.7165 54.1369 16.9048 54.3219C17.2478 54.6136 17.6893 54.7632 18.139 54.7401C18.262 54.7365 18.3841 54.7182 18.5028 54.6857C22.95 53.4039 27.6828 52.8293 33.847 52.8293H34.153C40.3172 52.8293 45.05 53.4039 49.4938 54.6857C49.6137 54.7179 49.7369 54.7361 49.861 54.7401C50.3008 54.766 50.7342 54.6252 51.0748 54.3457C51.265 54.1611 51.4163 53.9402 51.5197 53.696C51.6231 53.4519 51.6764 53.1896 51.6766 52.9245C51.6766 52.4893 51.9316 48.8445 52.0166 48.2189C52.1842 47.641 52.4574 47.0992 52.8224 46.6209C54.8658 43.4249 55.5016 40.2187 54.9712 35.8735ZM51.2278 45.4479C50.5478 46.4951 50.2248 47.2023 50.133 47.7497C50.0412 48.4637 49.793 52.3669 49.793 52.7477C45.2302 51.4897 40.2152 50.8573 34.017 50.7655C27.812 50.8573 22.797 51.4897 18.2308 52.7477C18.2308 52.3635 17.969 48.4637 17.8908 47.7633C17.7956 47.2023 17.459 46.4951 16.796 45.4513C14.9702 42.7143 14.416 39.8753 14.9396 35.9619C15.351 33.2181 16.201 23.8953 16.66 18.8905C16.7824 17.5305 16.881 16.4799 16.9354 15.9087C17.2176 15.7931 17.7786 15.5313 18.2342 15.3205C18.4756 15.2083 18.7476 15.0791 18.7952 15.0621L18.9618 15.5449L19.0434 15.8271C19.7846 18.3363 21.165 23.0079 23.63 25.7313C26.554 29.0191 30.5354 31.0863 34 31.1271C37.4612 31.0863 41.4392 29.0191 44.3836 25.7279C46.8486 23.0079 48.229 18.3363 48.9668 15.8271L49.0552 15.5313L49.2116 15.0587C49.2592 15.0757 49.5312 15.2049 49.7726 15.3171C50.2282 15.5279 50.7926 15.7897 51.0714 15.9053C51.1258 16.4765 51.221 17.5339 51.3468 18.8871C51.8024 23.8919 52.6558 33.2147 53.0672 35.9619C53.6044 39.8753 53.04 42.7143 51.2278 45.4479Z" fill="currentColor"/></svg>';
    function escapeHtml(s){ return String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])); }
    /* Label placeholder swap (e.g. "Select your band and cup" ↔ "2XL") */
    const sizeOptEl = bcRoot.closest('.ls-option');
    const labelSelectedEl = sizeOptEl ? sizeOptEl.querySelector('[data-option-selected]') : null;
    const placeholderEl  = sizeOptEl ? sizeOptEl.querySelector('[data-bc-placeholder]') : null;
    function setLabelMode(filled){
      if(!labelSelectedEl || !placeholderEl) return;
      if(filled){ placeholderEl.hidden = true;  labelSelectedEl.hidden = false; }
      else      { placeholderEl.hidden = false; labelSelectedEl.hidden = true;  }
    }
    function renderFits(size){
      if(!fitsEl) return;
      if(!size){ fitsEl.classList.remove('is-on'); fitsEl.innerHTML = ''; setLabelMode(false); return; }
      const sn = norm(size);
      const unitUpper = unit ? unit.toUpperCase() : '';
      const pairs = [];
      for(let i = 0; i < matrix.length; i++){
        const row = matrix[i] || [];
        for(let j = 0; j < row.length; j++){
          if(norm(row[j]) === sn && isAvail(row[j])){
            const band = bands[i] || '';
            const cup  = (cups[j] || '').toUpperCase();
            if(band && cup) pairs.push(band + (unitUpper ? ' ' + unitUpper : '') + ' ' + cup);
          }
        }
      }
      if(!pairs.length){ fitsEl.classList.remove('is-on'); fitsEl.innerHTML = ''; setLabelMode(false); return; }
      fitsEl.innerHTML = FITS_ICON +
        '<span class="ls-bc__fits-body">' +
          '<strong>' + escapeHtml(size) + '</strong> ' +
          '<span class="ls-bc__fits-lbl">' + escapeHtml(fitsPrefix) + '</span> ' +
          '<strong>' + escapeHtml(pairs.join(', ')) + '</strong>' +
        '</span>';
      fitsEl.classList.add('is-on');
      if(labelSelectedEl) labelSelectedEl.textContent = size;
      setLabelMode(true);
    }

    function bandCupToSize(){
      const bi = bandSel.value === '' ? -1 : parseInt(bandSel.value, 10);
      const ci = cupSel.value  === '' ? -1 : parseInt(cupSel.value,  10);
      if(bi < 0 || ci < 0) return '';
      const row = matrix[bi] || [];
      return row[ci] || '';
    }

    /* Find first (bandIdx, cupIdx) that maps to given size AND is available. */
    function firstBandCupForSize(size){
      const sn = norm(size);
      if(!sn) return null;
      for(let i = 0; i < matrix.length; i++){
        const row = matrix[i] || [];
        for(let j = 0; j < row.length; j++){
          if(norm(row[j]) === sn && isAvail(row[j])){
            return { bi: i, ci: j };
          }
        }
      }
      return null;
    }

    /* Reverse-fill Band+Cup dropdowns from a size value (preserve current selection if it already maps). */
    function syncBandCupToSize(size){
      if(!size) return;
      const sn = norm(size);
      const curBi = bandSel.value === '' ? -1 : parseInt(bandSel.value, 10);
      const curCi = cupSel.value  === '' ? -1 : parseInt(cupSel.value,  10);
      /* Already pointing at this size? keep it. */
      if(curBi >= 0 && curCi >= 0 && norm((matrix[curBi]||[])[curCi]) === sn) return;
      const pair = firstBandCupForSize(size);
      if(!pair) return;
      /* Make sure pair.bi exists in band options (it should — all available sizes resolved from valid bands). */
      if(Array.from(bandSel.options).some(o => o.value === String(pair.bi))){
        bandSel.value = String(pair.bi);
      }
      rebuildCupOptions(pair.bi);
      if(Array.from(cupSel.options).some(o => o.value === String(pair.ci))){
        cupSel.value = String(pair.ci);
      }
    }

    function syncSelectToPill(){
      const v = currentPillValue();
      if(!v) return;
      const match = Array.from(sizeSel.options).find(o => norm(o.value) === norm(v));
      if(match) sizeSel.value = match.value;
      syncBandCupToSize(v);
      renderFits(v);
      syncFlybundlesToSize(v);
    }

    /* Flybundle (Volume Discount app) sync — when main size changes, push it into every
       bundle Size dropdown via Flybundle's internal API. The bundle dropdowns are custom
       components (radio-backed) that ignore synthetic clicks; we have to mutate state
       directly and trigger their variant-rebuild. Tier-1 (single-buy) is synced by
       Flybundle natively via syncThemeVariantPicker, so we focus on multi-pack tiers. */
    function syncFlybundlesToSize(size){
      if(!size) return;
      if(root.__syncFlybundlesByOption) root.__syncFlybundlesByOption('Size', Math.max(0, productOptions.indexOf('Size')), size);
    }

    /* Band/Cup change → resolve size → click pill */
    function applySize(){
      const size = bandCupToSize();
      if(!size) return;
      const ok = clickPill(size);
      if(ok){
        const match = Array.from(sizeSel.options).find(o => norm(o.value) === norm(size));
        if(match) sizeSel.value = match.value;
        renderFits(size);
        syncFlybundlesToSize(size);
      }
    }
    bandSel.addEventListener('change', () => {
      const bi = bandSel.value === '' ? -1 : parseInt(bandSel.value, 10);
      const prevCup = cupSel.value;
      rebuildCupOptions(bi);
      /* Try to preserve cup selection if still valid */
      if(prevCup !== '' && Array.from(cupSel.options).some(o => o.value === prevCup)){
        cupSel.value = prevCup;
      }
      applySize();
    });
    cupSel.addEventListener('change', applySize);

    /* Manual size dropdown → click pill + reverse-fill Band+Cup + recompute fits */
    sizeSel.addEventListener('change', () => {
      const v = sizeSel.value;
      clickPill(v);
      syncBandCupToSize(v);
      renderFits(v);
      syncFlybundlesToSize(v);
    });

    /* React to pill clicks from other sources (e.g. swatch focus, external) */
    if(pillRow){
      pillRow.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-option-value]');
        if(!btn) return;
        /* defer to let existing handler run first */
        setTimeout(syncSelectToPill, 0);
      });
    }

    /* Init: keep Band+Cup empty (placeholder state), but reflect existing pill in fits/label only if user later picks. */
    setLabelMode(false);
  })();
  document.addEventListener('keydown', e => {
    if(!modal || modal.hidden) return;
    if(e.key === 'Escape'){ closeModal(); return; }
    if(e.key === 'Tab'){
      const f = modalFocusable();
      if(!f.length){ e.preventDefault(); return; }
      const first = f[0], last = f[f.length-1];
      if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
      else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
    }
  });

  /* ReelUp — fade in only when first video has loaded enough to paint a frame
     (kills white flash). Empty-state collapse if nothing renders in 6s. */
  const reel = document.querySelector('.reelUp_productpage_reels_js_widget');
  if(reel){
    let revealed = false;
    const reveal = () => {
      if(revealed) return;
      revealed = true;
      reel.classList.add('is-ready');
    };
    const tryAttachVideoListeners = () => {
      const vids = reel.querySelectorAll('video');
      if(!vids.length) return false;
      let any = false;
      vids.forEach(v => {
        if(v.readyState >= 1){ any = true; return; }
        /* loadedmetadata fires earlier than loadeddata → faster reveal */
        v.addEventListener('loadedmetadata', reveal, {once:true});
        v.addEventListener('loadeddata', reveal, {once:true});
      });
      if(any) reveal();
      return true;
    };
    /* Watch DOM until widget injects videos, then bind */
    const mo = new MutationObserver(() => {
      if(tryAttachVideoListeners()) mo.disconnect();
    });
    mo.observe(reel, {childList:true, subtree:true});
    /* Safety reveal: 2s max wait — fade in even if videos still buffering */
    setTimeout(reveal, 2000);
    /* Empty-state collapse */
    setTimeout(() => {
      if(!reel.children.length && !reel.textContent.trim()){
        reel.style.minHeight = '0';
        reel.style.margin = '0';
        reveal();
      }
    }, 6000);
  }

  /* Sticky bar scroll show — scoped + rAF-throttled */
  const stickyBar = document.querySelector('[data-sticky-bar][data-section-id="template--30061390332291__lsth_pdp_NCxGEW_lg"]');
  if(stickyBar){
    const offset = parseInt(stickyBar.dataset.scrollOffset, 10) || 1600;
    let stickyTicking = false;
    function onScroll(){
      if(stickyTicking) return;
      stickyTicking = true;
      requestAnimationFrame(() => {
        stickyBar.classList.toggle('is-visible', window.scrollY > offset);
        stickyTicking = false;
      });
    }
    window.addEventListener('scroll', onScroll, {passive: true});
    onScroll();
    /* Sticky CTA → scroll ATC into center of viewport */
    const stickyCta = stickyBar.querySelector('[data-sticky-cta]');
    if(stickyCta){
      stickyCta.addEventListener('click', (e) => {
        /* target = the visible offer: custom bundle first (the theme ATC is hidden when the bundle is on), then the theme ATC, then the buy box */
        const vis = (el) => el && el.offsetParent !== null && el.getBoundingClientRect().height > 0;
        const cands = [root.querySelector('#ls-bundle-offer'), root.querySelector('.ls-bundle__atc'), root.querySelector('[data-atc]'), root.querySelector('.ls-buy')];
        const atc = cands.find(vis); if(!atc) return;
        e.preventDefault();
        const rect = atc.getBoundingClientRect();
        const target = atc.id === 'ls-bundle-offer' ? window.scrollY + rect.top - 80 : window.scrollY + rect.top - (window.innerHeight / 2) + (rect.height / 2);
        window.scrollTo({top: Math.max(0, target), behavior: 'smooth'});
        let focused = false;
        const doFocus = () => { if(focused) return; focused = true; try { atc.focus({preventScroll:true}); } catch(_){} };
        window.addEventListener('scrollend', doFocus, {once:true});
        setTimeout(doFocus, 1000);
      });
    }
  }
})();

}).call(window, LSTH_DOC);

/* ---- script de la section lsth_quality_AEfbpm_lg ---- */
(function (document) {

(function(){
  /* speed round 2: lazy <video> (IO 1800px) + autoplay-denial tap-to-play + media-error poster fallback. Scoped per section. */
  var root = document.getElementById('lsth-quality'); if(!root || root.dataset.lsqVideoInit) return; root.dataset.lsqVideoInit = '1';
  var vids = Array.prototype.slice.call(root.querySelectorAll('video.lsq__media-el')); if(!vids.length) return;
  function box(el){ return el.parentNode; }
  function playBtn(v){ var b = box(v).querySelector('.lsq__play'); return b; }
  function fail(v){
    if(v.dataset.failed) return; v.dataset.failed = '1';
    var b = playBtn(v); if(b) b.hidden = true;
    var p = v.getAttribute('data-poster') || v.getAttribute('poster') || '';
    var w = v.getAttribute('width'), h = v.getAttribute('height'), st = v.getAttribute('style') || '';
    var ph = document.createElement('div'); ph.className = v.className.replace(/\blsic-lazy-video\b|\blsq-lazy-video\b/g, '').trim() + ' ls-video-fallback'; if(st) ph.setAttribute('style', st);
    if(p){
      var im = document.createElement('img'); im.className = ph.className; im.alt = v.getAttribute('aria-label') || ''; im.decoding = 'async';
      if(w) im.setAttribute('width', w); if(h) im.setAttribute('height', h); if(st) im.setAttribute('style', st);
      im.onerror = function(){ if(im.parentNode) im.parentNode.replaceChild(ph, im); };
      im.src = p; if(v.parentNode) v.parentNode.replaceChild(im, v);
    } else if(v.parentNode){ v.parentNode.replaceChild(ph, v); }
  }
  function activate(v){
    if(v.dataset.failed || v.dataset.activated) return; v.dataset.activated = '1';
    var sources = v.querySelectorAll('source[data-src]');
    if(sources.length){ Array.prototype.forEach.call(sources, function(s){ s.src = s.dataset.src; }); v.load(); }
    else if(v.dataset.src && !v.getAttribute('src')){ v.src = v.dataset.src; }
    else if(!v.dataset.src && v.getAttribute('src')){ /* eager video: already loading */ }
    v.autoplay = true;
    var b = playBtn(v);
    v.addEventListener('playing', function(){ if(b) b.hidden = true; });
    var p = v.play();
    if(p && p.catch) p.catch(function(){ if(v.dataset.failed) return; if(b){ b.hidden = false; } });
  }
  vids.forEach(function(v){
    v.addEventListener('error', function(){ fail(v); }, true);
    var b = playBtn(v);
    if(b) b.addEventListener('click', function(){ if(v.dataset.failed) return; var p = v.play(); if(p && p.catch) p.catch(function(){}); });
  });
  if(!('IntersectionObserver' in window)){ vids.forEach(activate); return; }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting){ activate(e.target); io.unobserve(e.target); } });
  }, { rootMargin: '1800px 0px' });
  vids.forEach(function(v){ io.observe(v); });
})();

}).call(window, LSTH_DOC);

/* ---- script de la section lsth_image_copy_WTTRgA_lg ---- */
(function (document) {

(function(){
  /* speed round 2: lazy <video> (IO 1800px) + autoplay-denial tap-to-play + media-error poster fallback. Scoped per section. */
  var root = document.getElementById('lsic-template--30061390332291__lsth_image_copy_WTTRgA_lg'); if(!root || root.dataset.lsicVideoInit) return; root.dataset.lsicVideoInit = '1';
  var vids = Array.prototype.slice.call(root.querySelectorAll('.lsic-lazy-video')); if(!vids.length) return;
  function box(el){ return el.parentNode; }
  function playBtn(v){ var b = box(v).querySelector('.lsic__play'); return b; }
  function fail(v){
    if(v.dataset.failed) return; v.dataset.failed = '1';
    var b = playBtn(v); if(b) b.hidden = true;
    var p = v.getAttribute('data-poster') || v.getAttribute('poster') || '';
    var w = v.getAttribute('width'), h = v.getAttribute('height'), st = v.getAttribute('style') || '';
    var ph = document.createElement('div'); ph.className = v.className.replace(/\blsic-lazy-video\b|\blsq-lazy-video\b/g, '').trim() + ' ls-video-fallback'; if(st) ph.setAttribute('style', st);
    if(p){
      var im = document.createElement('img'); im.className = ph.className; im.alt = v.getAttribute('aria-label') || ''; im.decoding = 'async';
      if(w) im.setAttribute('width', w); if(h) im.setAttribute('height', h); if(st) im.setAttribute('style', st);
      im.onerror = function(){ if(im.parentNode) im.parentNode.replaceChild(ph, im); };
      im.src = p; if(v.parentNode) v.parentNode.replaceChild(im, v);
    } else if(v.parentNode){ v.parentNode.replaceChild(ph, v); }
  }
  function activate(v){
    if(v.dataset.failed || v.dataset.activated) return; v.dataset.activated = '1';
    var sources = v.querySelectorAll('source[data-src]');
    if(sources.length){ Array.prototype.forEach.call(sources, function(s){ s.src = s.dataset.src; }); v.load(); }
    else if(v.dataset.src && !v.getAttribute('src')){ v.src = v.dataset.src; }
    else if(!v.dataset.src && v.getAttribute('src')){ /* eager video: already loading */ }
    v.autoplay = true;
    var b = playBtn(v);
    v.addEventListener('playing', function(){ if(b) b.hidden = true; });
    var p = v.play();
    if(p && p.catch) p.catch(function(){ if(v.dataset.failed) return; if(b){ b.hidden = false; } });
  }
  vids.forEach(function(v){
    v.addEventListener('error', function(){ fail(v); }, true);
    var b = playBtn(v);
    if(b) b.addEventListener('click', function(){ if(v.dataset.failed) return; var p = v.play(); if(p && p.catch) p.catch(function(){}); });
  });
  if(!('IntersectionObserver' in window)){ vids.forEach(activate); return; }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting){ activate(e.target); io.unobserve(e.target); } });
  }, { rootMargin: '1800px 0px' });
  vids.forEach(function(v){ io.observe(v); });
})();

}).call(window, LSTH_DOC);

/* ---- script de la section lsth_image_copy_EPYhfY_lg ---- */
(function (document) {

(function(){
  /* speed round 2: lazy <video> (IO 1800px) + autoplay-denial tap-to-play + media-error poster fallback. Scoped per section. */
  var root = document.getElementById('lsic-template--30061390332291__lsth_image_copy_EPYhfY_lg'); if(!root || root.dataset.lsicVideoInit) return; root.dataset.lsicVideoInit = '1';
  var vids = Array.prototype.slice.call(root.querySelectorAll('.lsic-lazy-video')); if(!vids.length) return;
  function box(el){ return el.parentNode; }
  function playBtn(v){ var b = box(v).querySelector('.lsic__play'); return b; }
  function fail(v){
    if(v.dataset.failed) return; v.dataset.failed = '1';
    var b = playBtn(v); if(b) b.hidden = true;
    var p = v.getAttribute('data-poster') || v.getAttribute('poster') || '';
    var w = v.getAttribute('width'), h = v.getAttribute('height'), st = v.getAttribute('style') || '';
    var ph = document.createElement('div'); ph.className = v.className.replace(/\blsic-lazy-video\b|\blsq-lazy-video\b/g, '').trim() + ' ls-video-fallback'; if(st) ph.setAttribute('style', st);
    if(p){
      var im = document.createElement('img'); im.className = ph.className; im.alt = v.getAttribute('aria-label') || ''; im.decoding = 'async';
      if(w) im.setAttribute('width', w); if(h) im.setAttribute('height', h); if(st) im.setAttribute('style', st);
      im.onerror = function(){ if(im.parentNode) im.parentNode.replaceChild(ph, im); };
      im.src = p; if(v.parentNode) v.parentNode.replaceChild(im, v);
    } else if(v.parentNode){ v.parentNode.replaceChild(ph, v); }
  }
  function activate(v){
    if(v.dataset.failed || v.dataset.activated) return; v.dataset.activated = '1';
    var sources = v.querySelectorAll('source[data-src]');
    if(sources.length){ Array.prototype.forEach.call(sources, function(s){ s.src = s.dataset.src; }); v.load(); }
    else if(v.dataset.src && !v.getAttribute('src')){ v.src = v.dataset.src; }
    else if(!v.dataset.src && v.getAttribute('src')){ /* eager video: already loading */ }
    v.autoplay = true;
    var b = playBtn(v);
    v.addEventListener('playing', function(){ if(b) b.hidden = true; });
    var p = v.play();
    if(p && p.catch) p.catch(function(){ if(v.dataset.failed) return; if(b){ b.hidden = false; } });
  }
  vids.forEach(function(v){
    v.addEventListener('error', function(){ fail(v); }, true);
    var b = playBtn(v);
    if(b) b.addEventListener('click', function(){ if(v.dataset.failed) return; var p = v.play(); if(p && p.catch) p.catch(function(){}); });
  });
  if(!('IntersectionObserver' in window)){ vids.forEach(activate); return; }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting){ activate(e.target); io.unobserve(e.target); } });
  }, { rootMargin: '1800px 0px' });
  vids.forEach(function(v){ io.observe(v); });
})();

}).call(window, LSTH_DOC);

/* ---- script de la section lsth_reviews_slider_igX4Hq_lg ---- */
(function (document) {

  (function(){
    var root  = document.getElementById('lsrev-template--30061390332291__lsth_reviews_slider_igX4Hq_lg');
    if(!root) return;
    var track = root.querySelector('[data-track]');
    if(!track) return;

    var autoplay = root.dataset.autoplay !== 'false';
    var delay    = parseInt(root.dataset.delay,10) || 1200;
    var prefersReduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(!autoplay || prefersReduced) return;

    /* ── Seamless infinite loop: clone children once ── */
    var originals = Array.prototype.slice.call(track.children);
    if(originals.length === 0) return;
    originals.forEach(function(c){ track.appendChild(c.cloneNode(true)); });

    var timer = null;
    var paused = false;
    var resumeTimeout = null;

    function step(){
      if(paused) return;
      var card = track.children[0];
      if(!card) return;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
      var slideW = card.getBoundingClientRect().width + gap;
      var halfWidth = track.scrollWidth / 2;

      /* if past clone region → snap back to mirrored origin (no visible jump) */
      if(track.scrollLeft >= halfWidth){
        var prev = track.style.scrollBehavior;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = track.scrollLeft - halfWidth;
        track.style.scrollBehavior = prev || '';
      }
      track.scrollBy({ left: slideW, behavior: 'smooth' });
    }

    function start(){ stop(); timer = setInterval(step, delay); }
    function stop(){  if(timer){ clearInterval(timer); timer = null; } }

    function pause(){
      paused = true;
      if(resumeTimeout){ clearTimeout(resumeTimeout); resumeTimeout = null; }
    }
    function scheduleResume(ms){
      if(resumeTimeout) clearTimeout(resumeTimeout);
      resumeTimeout = setTimeout(function(){ paused = false; }, ms || 2500);
    }

    /* Pause on hover (desktop) */
    track.addEventListener('mouseenter', pause);
    track.addEventListener('mouseleave', function(){ scheduleResume(400); });

    /* Pause on touch / manual scroll */
    track.addEventListener('touchstart', pause, { passive: true });
    track.addEventListener('touchend',   function(){ scheduleResume(2500); }, { passive: true });
    track.addEventListener('wheel',      function(){ pause(); scheduleResume(2500); }, { passive: true });

    /* Pause when off-screen */
    if('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if(e.isIntersecting) start();
          else stop();
        });
      }, { threshold: 0.15 });
      io.observe(root);
    } else {
      start();
    }
  })();

}).call(window, LSTH_DOC);

})();
